import React, { Component } from "react";
import { connect } from "react-redux";
import Txt from "../../shared/textInput";
import AddressForm from "../../shared/addressForm";
import {
  updateAppointmentStepData,
  getStaffServicesAndMore,
  getCustomersBasedOnFilter,
  updateIsShowingAddressForm,
  updatetemporaryBookingAddress,
  getBookingsForResourceWithinDates,
  updateCustomerDropdownVisibility,
  clearAddressFormInAppointmentStep,
  getProfileForCurrentUser,
} from "../../../actions/appointmentStep";
import {
  updateCurrentMenu,
  updateBookingCustomerProfileModalVisibility,
} from "../../../actions/menu";
import objectAssign from "object-assign";
import { Dropdown, Dimmer } from "semantic-ui-react";
import DatePicker from "react-datepicker";
import { findDOMNode } from "react-dom";
import moment from "moment";
import { updateAdvancedAppointmentStepData } from "../../../actions/appointmentAdvancedStep";
import {
  menuNamesEnum,
  paymentStatusEnum,
  initialServiceWithDefaultData,
  initialAdvancedServiceWithDefaultData,
} from "../../../state/initialState";
import {
  roundUpDurationInFiveMinutesInterval,
  parseTimeIntervalIntoMinutesAndHours,
  dateRangeOneDay,
  calculateTotalAppointmentDuration,
  addMultipleAppointmentDurations,
  getAmPmTime,
  get24sTime,
  convertDurationApi2ScreenFormat,
  apiLocalTimeToMoment,
  overlaps,
  isInRange,
} from "../../../utils/helpers";
import {
  getApiCustomerProfileData,
  updateCustomerProfileData,
  updateBookingOnlyCustomerProfileData,
  resetCustomerProfileForm,
  updateShouldSaveAppointmentOnceWeGoBackFromCustomerProfile,
} from "../../../actions/customerProfile";
import { ValidMe } from "../../shared/validMeReact";
import {
  getParents,
  getFinalListOfServicesWithAccessAndNoAccess,
  convertDateTimeFromApi,
  toApiDateTime,
  convertApiUtcToLocalMoment,
  canUserUseThisTimeDueToDoubleBookingDisabled,
  orderServicesInOrderMerchantCreatedInSettingsPages,
  checkIfNewTimeWillCauseDoubleBooking,
  formatPhone,
  getDateInATimeZone,
} from "../../../utils/helpers";
import {
  forceValidation,
  clearAllValidationErrors,
} from "../../shared/validMeReact";
import ReactArrowHandler from "../../shared/reactArrowHandler";
import {
  sendBookingEmail,
  getExistingBooking,
  getSibblingBooking,
} from "../../../actions/booking";
import { updateGlobalSuccessMessage } from "../../../actions/globalSuccess";
import { removeGlobalErrorMessageIfMatchesThisString } from "../../../actions/globalError";
import { saveAppointmentDataHandler } from "../../shared/functions/saveAppointmentDataHandler";
import { getInvoice } from "../../../actions/checkoutAppointmentStep";

import { clone } from "../../../reducers/helper";
import _ from "underscore";
import CenterPanelBookingOnlyCustomerProfile from "../booking-only-customer-profile/centerPanel";
const Draggable = require("draggable");

const MINIMUM_APPOINTMENT_TIME = "00:30";

const DEBOUNCED_TIME_IN_MILLISECONDS = 500;

@connect(mapStateToProps)
export default class CenterPanelAppointment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      handleClickOutsideService: (e) => {
        if (
          !(e.target.className.indexOf("service-dropdown") > -1) &&
          getParents(e.target, ".service-dropdown").length == 0 &&
          !(e.target.className.indexOf("close_button2") > -1)
        ) {
          //this means the click did not happen inside the dropdown
          this.props.appointmentStepData.multiServiceList.forEach(
            (o, multiItemIndex) => {
              this.updateServiceDropdownVisibility(
                false,
                undefined,
                undefined,
                undefined,
                multiItemIndex
              );
            }
          );
        }
      },
      handleClickOutsideCustomerList: (e) => {
        if (
          !(e.target.className.indexOf("customer-dropdown") > -1) &&
          getParents(e.target, ".customer-dropdown").length == 0 &&
          !(e.target.className.indexOf("close_button2") > -1)
        ) {
          //this means the click did not happen inside the dropdown
          let visible = false;
          this.props.dispatch(updateCustomerDropdownVisibility(visible));
        }
      },
      handleClickOutsideTimeList: (e) => {
        if (
          !(e.target.className.indexOf("time-dropdown") > -1) &&
          getParents(e.target, ".time-dropdown").length == 0 &&
          !(e.target.className.indexOf("close_button2") > -1)
        ) {
          //this means the click did not happen inside the dropdown
          this.props.appointmentStepData.multiServiceList.forEach(
            (o, multiItemIndex) => {
              this.updateTimeDropdownVisibility(
                false,
                undefined,
                undefined,
                undefined,
                multiItemIndex
              );
            }
          );
        }
      },
      handleClickOutsideCustomerComments: (e) => {
        if (
          !(e.target.className.indexOf("full-view-container") > -1) &&
          getParents(e.target, ".full-view-container").length == 0 &&
          !(e.target.className.indexOf("close_button2") > -1)
        ) {
          //this means the click did not happen inside the dropdown
          this.updateThisStep({
            showMemoFullView: false,
          });
        }
      },
      tookSnapshotOfCurrentStep: false,
      tookSnapshotOfCurrentStepDuringInitialization: false,
      hoveredAppUsageIcon: false,
      hoveredNoAccessToolTip: false,
      madeAppDraggable: false,
      debouncedSearchOfCustomers: _.debounce(
        this.handleChangeOfCustomerSearch,
        DEBOUNCED_TIME_IN_MILLISECONDS
      ),
      showOfflineModal: true,
    };
  }

  dispatchGetCustomerProfileDetails = (customerId) => {
    this.props.dispatch(getApiCustomerProfileData(customerId));
  };

  areServicesStillLoading = (
    nextAppointmentStepData,
    nextLoadingBooking,
    nextCurrentBookingId
  ) => {
    let { appointmentStepData } = this.props;

    let servicesWithCompleteData = appointmentStepData.multiServiceList.filter(
      (x) => x.loadedBookingForResourceWithinDates
    );
    let servicesStillLoading =
      servicesWithCompleteData.length !=
      appointmentStepData.multiServiceList.length;

    if (servicesStillLoading && nextAppointmentStepData) {
      //check if in the next cycle props are still loading so we get more accurate results

      servicesWithCompleteData = nextAppointmentStepData.multiServiceList.filter(
        (x) => x.loadedBookingForResourceWithinDates
      );
      servicesStillLoading =
        servicesWithCompleteData.length !=
        nextAppointmentStepData.multiServiceList.length;
    }

    if (
      appointmentStepData.multiServiceList[0]
        .loadedBookingForResourceWithinDates
    ) {
      // DES-728 we dont need availabilities of sibblings for multiservice appointments atm.
      servicesStillLoading = false;
    }

    return servicesStillLoading;
  };

  componentWillReceiveProps(nextProps) {
    let {
      customerProfileData: { firstName, lastName, id },
      appointmentStepData: {
        selectedCustomer,
        bookingObtainedFromDbWithCustomer,
        multiServiceList,
        triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot,
      },
      currentBookingId,
      loadingBooking,
      appointmentStepData,
      advancedAppointmentStepData,
      previousMenu,
      gotCustomerProfileData,
      sibblingBookingIds,
      finishedLoadingSibblingBookings,
      finishedLoadingBooking,
      loadedCachedData,
      limitedPermissions,
      isSibblingsMissingInUpdate,
      isMultiServiceAppointment,
      finishedLoadingSibblingResources,
      loadedResourcesForAllSibblings,
      bookingOnlyCustomerProfileData,
    } = nextProps;

    if (!this.state.madeAppDraggable) {
      this.setState({ madeAppDraggable: true }, () => {
        let element = document.body;
        let options = {
          handle: document.getElementsByClassName("drag-handler")[0],
        };
        new Draggable(element, options);
      });
    }

    let servicesStillLoading = this.areServicesStillLoading(
      nextProps.appointmentStepData,
      loadingBooking,
      currentBookingId
    );

    const takeSnapshotOfAppToUseInSaveChangesModalForScenariosWithCustomer = () => {
      if (!window.appIsClosing && this.props.currentBookingId) {
        let finishedLoadingCustomer =
          !limitedPermissions.canViewCustomerProfile ||
          (selectedCustomer && selectedCustomer.id
            ? gotCustomerProfileData && bookingObtainedFromDbWithCustomer
            : !!firstName || !!lastName);
        if (
          finishedLoadingCustomer &&
          ((!this.state.tookSnapshotOfCurrentStep &&
            previousMenu !=
              menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_PROFILE_EDIT) ||
            (isMultiServiceAppointment &&
              loadedResourcesForAllSibblings > 0)) &&
          !servicesStillLoading &&
          (!previousMenu ||
            previousMenu != menuNamesEnum.SECOND_STEP_ADVANCED) &&
          (!isMultiServiceAppointment ||
            (finishedLoadingSibblingBookings &&
              finishedLoadingSibblingResources))
        ) {
          sessionStorage.setItem(
            "BOOKING_APPOINTMENT_SNAPSHOT",
            JSON.stringify({ appointmentStepData, advancedAppointmentStepData })
          ); //we take a snapshot to compare when closing the form
          this.setState({ tookSnapshotOfCurrentStep: true });
        }
      }
    };
    const takeSnapshotOfAppToUseInSaveChangesModalForScenariosWithoutCustomer = () => {
      if (
        nextProps.finishedLoadingServicesAndOrganizationData &&
        !servicesStillLoading &&
        !this.state.tookSnapshotOfCurrentStepDuringInitialization &&
        previousMenu != menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_PROFILE_EDIT &&
        (!previousMenu || previousMenu != menuNamesEnum.SECOND_STEP_ADVANCED) &&
        (!isMultiServiceAppointment || finishedLoadingSibblingBookings)
      ) {
        sessionStorage.setItem(
          "BOOKING_APPOINTMENT_SNAPSHOT",
          JSON.stringify({ appointmentStepData, advancedAppointmentStepData })
        ); //we take a snapshot to compare when closing the form

        this.setState({ tookSnapshotOfCurrentStepDuringInitialization: true });
      }
    };
    takeSnapshotOfAppToUseInSaveChangesModalForScenariosWithCustomer();
    takeSnapshotOfAppToUseInSaveChangesModalForScenariosWithoutCustomer();

    if (
      nextProps.appointmentStepData.invoiceKey &&
      !nextProps.appointmentStepData.paymentStatusReceived &&
      !nextProps.appointmentStepData.loadingInvoice
    ) {
      this.props.dispatch(getInvoice(nextProps.appointmentStepData.invoiceKey));
    }

    if (
      !window.appIsClosing &&
      nextProps.appointmentStepData.selectedCustomer
    ) {
      let {
        appointmentStepData: {
          selectedCustomer: { id, noShow },
        },
      } = nextProps;
      if (
        id &&
        !nextProps.loadingCustomerProfile &&
        limitedPermissions.canViewCustomerProfile != false &&
        !firstName &&
        !lastName &&
        window.customerCounter < 2
      ) {
        //fetch customer always to see if the current user can see the profile
        window.customerCounter += 1; //DES-817 restrict indefinite api calls
        this.dispatchGetCustomerProfileDetails(
          nextProps.appointmentStepData.selectedCustomer.id
        );
      }
    }

    let mainService = multiServiceList[0];
    let loadFromCacheOrDragDrop =
      loadedCachedData ||
      triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot; // while drag and drop the saga for loadsibblings should have been called which dint happen. Hence this workaround
    if (
      (loadFromCacheOrDragDrop &&
        finishedLoadingBooking &&
        !finishedLoadingSibblingBookings &&
        currentBookingId &&
        sibblingBookingIds &&
        sibblingBookingIds.length > 0 &&
        sibblingBookingIds.length > multiServiceList.length - 1) ||
      (sibblingBookingIds && isSibblingsMissingInUpdate)
    ) {
      //we ignore the current service, so we do - 1
      let payload = { data: {} };
      sibblingBookingIds
        .filter((x) => !multiServiceList.find((x2) => x2.bookingId == x.id))
        .forEach((o, i) => {
          //filter out bookings we already have
          if (
            o.id != currentBookingId &&
            !nextProps[`loadingSibblingBooking_${o.id}`] &&
            !this.props[`loadingSibblingBooking_${o.id}`] &&
            !this[`throttledLoadOfBooking${o.id}`]
          ) {
            this[`throttledLoadOfBooking${o.id}`] = true;
            payload.bookingId = o.id;
            payload.data.advancedAppointmentStepData = advancedAppointmentStepData;
            payload.data.appointmentStepData = appointmentStepData;

            this.props.dispatch(getSibblingBooking(payload));
            setTimeout(() => {
              this[`throttledLoadOfBooking${o.id}`] = false;
            }, 1); //do this after the dispatch above had time to mark the loading as true
          }
        });
    }

    if (
      !bookingOnlyCustomerProfileData.firstName &&
      selectedCustomer.firstname
    ) {
      const bookingCustomerProfile = {};

      bookingCustomerProfile.email = selectedCustomer.email || "";
      bookingCustomerProfile.phoneNumber = selectedCustomer.phone || "";
      bookingCustomerProfile.firstName = selectedCustomer.firstname || "";
      bookingCustomerProfile.lastName = selectedCustomer.lastname || "";
      bookingCustomerProfile.address = selectedCustomer.address || {};

      this.props.dispatch(
        updateBookingOnlyCustomerProfileData(bookingCustomerProfile)
      );
    }

    // When searching for a customer, the address is not part of the result, so an extra api call is made
    // the address data needs to be added later
    if (
      bookingOnlyCustomerProfileData.address &&
      !bookingOnlyCustomerProfileData.address.id &&
      !selectedCustomer.address &&
      appointmentStepData.address &&
      appointmentStepData.address.id
    ) {
      const bookingCustomerProfile = {};

      bookingCustomerProfile.email = selectedCustomer.email || "";
      bookingCustomerProfile.phoneNumber = selectedCustomer.phone || "";
      bookingCustomerProfile.firstName = selectedCustomer.firstname || "";
      bookingCustomerProfile.lastName = selectedCustomer.lastname || "";
      bookingCustomerProfile.address = appointmentStepData.address || {};

      this.props.dispatch(
        updateBookingOnlyCustomerProfileData(bookingCustomerProfile)
      );
    }
  }

  componentWillMount() {
    // setTimeout(()=>{
    //   window.dispatch(getExistingBooking({bookingId : '167672662',data : {
    //     appointmentStepData : this.props.appointmentStepData,
    //     advancedAppointmentStepData : this.props.advancedAppointmentStepData
    //   }}));
    // },600);
  }

  componentDidMount() {
    let {
      previousMenu,
      appointmentStepData,
      advancedAppointmentStepData,
      advancedAppointmentStepDataFromLastSave,
      gotValidOffer,
      isMultiServiceAppointment,
      shouldSaveAppointmentOnceWeGoBackFromCustomerProfile,
      currentBookingId,
    } = this.props;
    let {
      customerNameOrPhonenumberSearchQuery,
    } = this.props.appointmentStepData;

    if (window.self === window.top)
      //load staff and services on our own if we are not on an iframe
      this.props.dispatch(getStaffServicesAndMore());

    document.body.addEventListener(
      "click",
      this.state.handleClickOutsideService
    );
    document.body.addEventListener(
      "click",
      this.state.handleClickOutsideTimeList
    );
    document.body.addEventListener(
      "click",
      this.state.handleClickOutsideCustomerList
    );
    document.body.addEventListener(
      "click",
      this.state.handleClickOutsideCustomerComments
    );

    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (iOS) {
      document.body.style.cursor = "pointer"; //DES-777 to make click event to fire in ios.
    }

    // TODO: Try to add onclick event for body to support handleClickOutsideTimeList and timedropdown Onblur event (trial for DES-777)
    let canWeIgnoreBookingId = false;
    if (
      previousMenu &&
      previousMenu ==
        menuNamesEnum.INTERMEDIATE_STEP_BOOKING_ONLY_CUSTOMER_PROFILE
    ) {
      canWeIgnoreBookingId = true;
    }

    if (
      previousMenu &&
      (previousMenu ==
        menuNamesEnum.INTERMEDIATE_STEP_BOOKING_ONLY_CUSTOMER_PROFILE ||
        previousMenu ==
          menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_PROFILE_CREATE ||
        previousMenu ==
          menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_PROFILE_EDIT) &&
      shouldSaveAppointmentOnceWeGoBackFromCustomerProfile &&
      (canWeIgnoreBookingId || currentBookingId)
    ) {
      let cb = () => {};
      let forceSave = true;
      let closeWhenSaved = false;

      this.props.dispatch(
        updateShouldSaveAppointmentOnceWeGoBackFromCustomerProfile(false)
      );

      if (!currentBookingId) {
        if (customerNameOrPhonenumberSearchQuery != "") {
          this.updateThisStep({
            customerNameOrPhonenumberSearchQuery: "",
          }); //reset search
        }
        appointmentStepData.customerNameOrPhonenumberSearchQuery = ""; //reset search
      }

      //this is here because if we make changes in the customer section it will affect the state of the booking
      sessionStorage.setItem(
        "BOOKING_APPOINTMENT_SNAPSHOT",
        JSON.stringify({ appointmentStepData, advancedAppointmentStepData })
      ); //we take a snapshot to compare when closing the form
      saveAppointmentDataHandler(
        this.props.dispatch,
        appointmentStepData,
        advancedAppointmentStepData,
        currentBookingId,
        advancedAppointmentStepDataFromLastSave,
        cb,
        forceSave,
        isMultiServiceAppointment,
        gotValidOffer,
        closeWhenSaved
      );
    }
  }

  componentWillUnmount() {
    document.body.removeEventListener(
      "click",
      this.state.handleClickOutsideService
    );
    document.body.removeEventListener(
      "click",
      this.state.handleClickOutsideTimeList
    );
    document.body.removeEventListener(
      "click",
      this.state.handleClickOutsideCustomerList
    );
    document.body.removeEventListener(
      "click",
      this.state.handleClickOutsideCustomerComments
    );
  }

  getDatesAvailableForCurrentStaffOnSelectedDate = (
    newlySelectedDate,
    newlySelectedStaffId,
    multiServiceItem,
    callback = false
  ) => {
    let {
      appointmentStepData: { multiServiceList },
      finishedLoadingBooking,
      currentBookingId,
    } = this.props;
    let { selectedStaff, selectedDate } = multiServiceItem;
    if (!newlySelectedDate) newlySelectedDate = selectedDate;
    if (!newlySelectedStaffId) newlySelectedStaffId = selectedStaff.id;

    if (
      (!multiServiceItem.loadedBookingForResourceWithinDates &&
        !multiServiceItem.loadingTimesForCurrentResource &&
        newlySelectedStaffId &&
        (currentBookingId ? finishedLoadingBooking : true)) ||
      callback
    ) {
      const rangedDate = dateRangeOneDay(newlySelectedDate);
      const indexMultiService = multiServiceList.indexOf(multiServiceItem);
      //this[`loadedTimes${indexMultiService}`] = true; //this is here because redux is async and otherwise we would make too many api calls
      if (callback) {
        this.props.dispatch(
          getBookingsForResourceWithinDates(
            newlySelectedStaffId,
            rangedDate.apiStartDate,
            rangedDate.apiEndDate,
            multiServiceItem.bookingId,
            this.checkDoubleBookingforDateStaffChange,
            multiServiceItem
          )
        );
      } else {
        this.props.dispatch(
          getBookingsForResourceWithinDates(
            newlySelectedStaffId,
            rangedDate.apiStartDate,
            rangedDate.apiEndDate,
            multiServiceItem.bookingId,
            null,
            multiServiceItem
          )
        );
      }
    }
  };

  dispatchUpdateCurrentMenu = (menuSelected) => {
    this.props.dispatch(updateCurrentMenu(menuSelected));
  };
  dispatchUpdateAppointmentStepData = (appointmentStepData) => {
    this.props.dispatch(updateAppointmentStepData(appointmentStepData));
  };

  dispatchUpdateAdvancedAppointmentStepData = (advancedAppointmentStepData) => {
    this.props.dispatch(
      updateAdvancedAppointmentStepData(advancedAppointmentStepData)
    );
  };

  updateAdvancedAppointmentStepData = (data, multiItemIndexAdvanced) => {
    let { multiServiceAdvancedList } = this.props.advancedAppointmentStepData;
    let newData = "";
    newData = clone(this.props.advancedAppointmentStepData);
    if (multiItemIndexAdvanced != undefined) {
      newData.multiServiceAdvancedList[multiItemIndexAdvanced] = objectAssign(
        {},
        multiServiceAdvancedList[multiItemIndexAdvanced],
        data
      );
    } else {
      newData = objectAssign({}, this.props.advancedAppointmentStepData, data);
    }

    this.dispatchUpdateAdvancedAppointmentStepData(newData);
  };

  updateThisStep = (data, multiItemIndex) => {
    let { multiServiceList } = this.props.appointmentStepData;
    let newData = "";

    newData = clone(this.props.appointmentStepData);
    if (multiItemIndex != undefined) {
      newData.multiServiceList[multiItemIndex] = objectAssign(
        {},
        multiServiceList[multiItemIndex],
        data
      );
    } else {
      newData = objectAssign({}, this.props.appointmentStepData, data);
    }

    this.dispatchUpdateAppointmentStepData(newData);
  };

  updateTimeDropdownVisibility = (
    visible,
    classNames = "",
    parentClassNames = "",
    forceHide,
    multiItemIndex
  ) => {
    if (
      classNames.indexOf("text") > -1 ||
      classNames.indexOf("search") > -1 ||
      parentClassNames.indexOf("text") > -1
    )
      visible = true;
    else {
      visible = false;
    }

    if (forceHide != undefined && !forceHide.type) visible = forceHide;

    setTimeout(() => {
      this.updateThisStep(
        {
          timeDropdownOpen: visible,
        },
        multiItemIndex
      );
    }, 0); // this is here to run AFTER the focus event of the service
  };

  updateServiceDropdownVisibility = (
    visible,
    classNames = "",
    parentClassNames = "",
    forceHide,
    multiItemIndex
  ) => {
    if (
      classNames.indexOf("text") > -1 ||
      classNames.indexOf("search") > -1 ||
      parentClassNames.indexOf("text") > -1
    )
      visible = true;
    else {
      visible = false;
    }

    if (forceHide != undefined && !forceHide.type) visible = forceHide;

    this.updateThisStep(
      {
        serviceDropdownOpen: visible,
      },
      multiItemIndex
    );
  };

  getStatusDropdown = () => {
    let {
      statusList,
      selectedAppointmentStatus,
      isNewBooking,
      confirmationSent,
      selectedCustomer,
      timeList,
      multiServiceList,
    } = this.props.appointmentStepData;
    let {
      currentBookingId,
      sendingBookingEmail,
      limitedPermissions,
      loadingCustomerProfile,
    } = this.props;
    let { selectedDate, selectedTime } = multiServiceList[0];

    let noShowsBox = "";

    let handleSelectStatus = (status) => {
      this.updateThisStep({
        selectedAppointmentStatus: status,
      });
    };

    let resendConfirmation = () => {
      let startTime = toApiDateTime(
        selectedDate,
        selectedTime.stringValue,
        timeList
      );
      this.props.dispatch(
        sendBookingEmail(
          currentBookingId,
          selectedAppointmentStatus.id,
          null,
          startTime
        )
      );
    };

    let reSendLink = "";
    let linkClasses = "";
    let resendEmailClasses = "resent-confirmation hand";

    let apiStartTime = toApiDateTime(
      selectedDate,
      selectedTime.stringValue,
      timeList
    );
    let dateTimeConverted = "";
    if (apiStartTime && window.userTimezone) {
      dateTimeConverted = convertApiUtcToLocalMoment(
        apiStartTime,
        window.userTimezone
      );
    }

    let convertedDay = getDateInATimeZone(window.userTimezone);
    if (
      dateTimeConverted &&
      dateTimeConverted.isBefore &&
      dateTimeConverted.isBefore(convertedDay)
    ) {
      reSendLink = "";
    } else if (currentBookingId && selectedCustomer && selectedCustomer.email) {
      if (sendingBookingEmail) {
        resendEmailClasses += " loading disabled-insensitive disabled";
        linkClasses += " loading disabled-insensitive disabled";
      }
      reSendLink = (
        <div className={resendEmailClasses} onClick={resendConfirmation}>
          <a className={linkClasses}>
            {window.APP.LANGUAGE.Pages.Appointment.ResendConfirmation}
          </a>
        </div>
      );
    } else if (confirmationSent && currentBookingId) {
      reSendLink = (
        <div className={resendEmailClasses} onClick={resendConfirmation}>
          <a>{window.APP.LANGUAGE.Pages.Appointment.ConfirmationResent}</a>
        </div>
      );
    }

    let getStatusWord = (statusId) => {
      switch (statusId) {
        case 2:
          return window.APP.LANGUAGE.Pages.Appointment.StatusListBooked;
        case 3:
          return window.APP.LANGUAGE.Pages.Appointment.StatusListBooked;
        case 4:
          return window.APP.LANGUAGE.Pages.Appointment.StatusListCompleted;
        case 5:
          return window.APP.LANGUAGE.Pages.Appointment.StatusListCancelled;
        case 6:
          return window.APP.LANGUAGE.Pages.Appointment.StatusListCancelled;
        case 8:
          return window.APP.LANGUAGE.Pages.Appointment.StatusListNoShow;
        default:
          return window.APP.LANGUAGE.Pages.Appointment
            .StatusDropdownPlaceholder;
      }
    };

    if (
      ((selectedCustomer.noShow && selectedCustomer.noShow != "") ||
        selectedAppointmentStatus.id == 8) &&
      selectedCustomer.id
    ) {
      if (selectedCustomer.noShow && selectedAppointmentStatus.id == 8) {
        selectedCustomer.noShow + 1;
      }
      noShowsBox = (
        <div className="no-show">
          {selectedCustomer.firstName || ""}
          <span className="no-show-hover">
            {selectedCustomer.noShow || 1}&nbsp;no-shows
          </span>
        </div>
      );
    }

    if (selectedAppointmentStatus.id != 5) {
      //remove status cancelled when current state is not cancelled
      statusList = statusList.filter((x) => x.id != 5);
    }

    let listWithAddedName = statusList.map((x) => {
      x.name = getStatusWord(x.id);
      return x;
    });

    let disabled = false;

    if (
      !limitedPermissions.canEditAllBookings &&
      limitedPermissions.bookingsEditableByCurrentUser.indexOf(
        currentBookingId
      ) < 0 &&
      currentBookingId
    ) {
      disabled = true;
    }

    if (!disabled) {
      disabled =
        selectedAppointmentStatus.id == 5 || selectedAppointmentStatus.id == 6;
    }
    if (!disabled) {
      disabled = loadingCustomerProfile;
    }

    return (
      <div className="status-section">
        {noShowsBox}
        <div>
          <ReactArrowHandler
            list={listWithAddedName}
            idProperty={"id"}
            textProperty={"name"}
            current={selectedAppointmentStatus}
          >
            <Txt
              type="dropdown"
              className={`status-dropdown selection ${
                selectedAppointmentStatus.id ? "value-selected" : ""
              }`}
              disabled={!currentBookingId || disabled || loadingCustomerProfile}
              placeholder={
                window.APP.LANGUAGE.Pages.Appointment.StatusDropdownPlaceholder
              }
              text={getStatusWord(selectedAppointmentStatus.id)}
            >
              <Dropdown.Menu>
                {listWithAddedName.map((status) => {
                  return (
                    <Dropdown.Item
                      disabled={status.id == 5 || status.id == 6}
                      key={status.id}
                      className={`${
                        status.id == selectedAppointmentStatus.id
                          ? "hovered"
                          : ""
                      }`}
                      onClick={handleSelectStatus.bind(this, status)}
                    >
                      {status.name}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Txt>
          </ReactArrowHandler>
          {reSendLink}
        </div>
      </div>
    );
  };

  isCustomerBlocked = () => {
    const {
      loadingCustomerProfile,
      appointmentStepData: { selectedCustomer },
    } = this.props;
    const { BlockedCustomerMessage } = window.APP.LANGUAGE.Pages.Appointment;
    if (
      selectedCustomer.id &&
      !loadingCustomerProfile &&
      selectedCustomer.blocked
    ) {
      this.props.dispatch(
        updateGlobalSuccessMessage({
          message: BlockedCustomerMessage,
          icon: "info_icon",
        })
      );
    }
  };

  getServiceDropdown = (
    multiServiceItem,
    multiItemIndex,
    sortedIndex,
    disabled = false
  ) => {
    let {
      selectedService,
      appointmentDuration,
      serviceSearchQuery,
      serviceDropdownOpen,
      selectedStaff,
    } = multiServiceItem;
    let {
      serviceList,
      paymentStatus,
      address,
      selectedAppointmentStatus,
      selectedCustomer,
    } = this.props.appointmentStepData;
    let {
      bookingChannel,
      finishedLoadingServicesAndOrganizationData,
      loadingBooking,
      currentBookingId,
      gotValidOffer,
      loadingCustomerProfile,
    } = this.props;
    let {
      ServiceDropdownPlaceholder,
      OfferTypeServiceLabel,
    } = window.APP.LANGUAGE.Pages.Appointment;
    let {
      ServiceDeliveredAtCustomerAddressInfomessage,
    } = window.APP.LANGUAGE.Success;

    if (currentBookingId != multiServiceItem.bookingId) {
      // i am therefore a sibbling
      disabled = true;
      if (this.props[`loadingSibblingBooking_${multiServiceItem.bookingId}`]) {
        loadingBooking = true;
      } else {
        loadingBooking = false;
      }
    }

    if (!disabled) {
      disabled = loadingCustomerProfile;
    }

    let handleServiceSearchChange = (e, { searchQuery }) => {
      this.updateThisStep(
        {
          serviceSearchQuery: searchQuery,
        },
        multiItemIndex
      );
    };

    let handleSelectService = (serviceSelected, ev) => {
      serviceSelected = clone(serviceSelected); //to avoid updating the service on the dropdown list
      let visible = false;
      if (serviceSelected.price == null) {
        serviceSelected.price = "0.00";
      }

      this.updateServiceDropdownVisibility(
        visible,
        undefined,
        undefined,
        undefined,
        multiItemIndex
      );

      if (
        multiItemIndex == 0 &&
        serviceSelected.atcustomeraddress &&
        ((address || {}).address1 || "").length == 0
      ) {
        this.props.dispatch(
          updateGlobalSuccessMessage({
            message: ServiceDeliveredAtCustomerAddressInfomessage,
            icon: "address_icon",
          })
        );
      }

      if (ev) {
        this.updateAdvancedAppointmentStepData(
          {
            splitAppointmentFreeTime: convertDurationApi2ScreenFormat(
              serviceSelected.availableduration || ""
            ),
            splitAppointmentFinishTime: convertDurationApi2ScreenFormat(
              serviceSelected.secondduration || ""
            ),
            splitAppointmentBufferTime: convertDurationApi2ScreenFormat(
              serviceSelected.bufferpostduration || ""
            ),
          },
          multiItemIndex
        );
      }

      this.updateThisStep(
        {
          serviceDropdownOpen: false,
          selectedService: serviceSelected,
          appointmentDuration: ev
            ? serviceSelected
              ? serviceSelected.duration
              : appointmentDuration
            : appointmentDuration,
          serviceSearchQuery: "", //reset search after selection
        },
        multiItemIndex
      );

      if (ev) {
        this.getDatesAvailableForCurrentStaffOnSelectedDate(
          null,
          null,
          multiServiceItem,
          true
        );
      }
    };

    let handleBlur = () => {
      let visible = false;
      this.updateServiceDropdownVisibility(
        visible,
        undefined,
        undefined,
        undefined,
        multiItemIndex
      );
    };

    let bookingChannelLabel = "";
    if (gotValidOffer) {
      bookingChannelLabel = OfferTypeServiceLabel + " ";
    } else if (bookingChannel && bookingChannel.name === "groupon") {
      bookingChannelLabel = "GRPN: ";
    } else if (bookingChannel && bookingChannel.name === "pingup") {
      bookingChannelLabel = "PINGUP: ";
    } else if (bookingChannel && bookingChannel.id == 4) {
      bookingChannelLabel = "GOOG: ";
    }

    let getServiceItem = (service) => {
      if (serviceList.length > 0 && service.id && !service.name) {
        service = objectAssign(
          {},
          serviceList.find((x) => x.id == service.id),
          service
        );
        // if (multiServiceItem.offerPrice){
        //   service.price = multiServiceItem.offerPrice;
        // }
        handleSelectService(service);
      }
      let itemToReturn = "";
      if (service.name) {
        if (service.price == null) {
          service.price = "0.00";
          service.defaultPrice = "0.00";
        }

        if (!service.defaultPrice) {
          service.defaultPrice = service.price; // DES-796
        }
        itemToReturn = (
          <div className="item">
            <span className="service-name">
              {bookingChannelLabel}
              {service.name}
            </span>
            <div className="service-price">
              {service.defaultPrice || service.price //DES-727
                ? "$"
                : ""}
              {service.defaultPrice || service.price}
            </div>
          </div>
        );
      }
      return itemToReturn;
    };

    let handleFocus = (ev) => {
      let visible = true;
      this.updateServiceDropdownVisibility(
        visible,
        ev.target.className,
        ev.target.parentElement.parentElement.className,
        undefined,
        multiItemIndex
      );
    };

    let closeButton = <div></div>;

    let listToRender = serviceList
      .filter((o) =>
        o.name
          .toLowerCase()
          .includes((serviceSearchQuery.toLowerCase() || "").trim())
      )
      .filter((x) => !x.deleted)
      .filter((x) => !x.hidden)
      .filter((x) => x.resources.indexOf(selectedStaff.id) > -1);

    listToRender = orderServicesInOrderMerchantCreatedInSettingsPages(
      listToRender
    );

    let isDisabled =
      !finishedLoadingServicesAndOrganizationData ||
      paymentStatus == paymentStatusEnum.STATUS_PAID ||
      loadingBooking ||
      disabled ||
      bookingChannelLabel.length > 0 ||
      selectedAppointmentStatus.id == 5 ||
      selectedAppointmentStatus.id == 6; //|| paymentStatus == paymentStatusEnum.STATUS_PARTIAL DES-771

    if (
      !isDisabled &&
      paymentStatus !== paymentStatusEnum.STATUS_PARTIAL &&
      !loadingBooking &&
      finishedLoadingServicesAndOrganizationData &&
      selectedService &&
      selectedService.id &&
      (paymentStatus == paymentStatusEnum.STATUS_UNPAID ||
        !paymentStatus ||
        paymentStatus == paymentStatusEnum.STATUS_UNKNOWN) &&
      !gotValidOffer &&
      bookingChannelLabel.length == 0 &&
      selectedAppointmentStatus.id != 5 &&
      !loadingCustomerProfile
    ) {
      closeButton = (
        <button
          type="button"
          tabIndex="-1"
          onClick={() => {
            handleSelectService({});
          }}
          className={`clear_button_service ${
            sortedIndex == 0 ? "first-row" : ""
          }`}
        ></button>
      );
    }

    let getServiceDropdownList = () => {
      // || paymentStatus==paymentStatusEnum.STATUS_PARTIAL DES-771
      return (
        <div className="serviceDropdownSection">
          <Txt
            onBlur={handleBlur}
            tabIndex={`${isDisabled ? "-1" : "0"}`}
            onFocus={handleFocus}
            type="dropdown"
            open={serviceDropdownOpen}
            disabled={isDisabled}
            loading={
              !finishedLoadingServicesAndOrganizationData || loadingBooking
            }
            title={
              sortedIndex == 0
                ? window.APP.LANGUAGE.Pages.Appointment.ServiceDropdownTitle
                : ""
            }
            placeholder={ServiceDropdownPlaceholder}
            className={`service-dropdown  selection on-focus-hide ${
              gotValidOffer ? "offer-locked-down-service" : ""
            } ${selectedService.id ? "value-selected" : ""} ${
              paymentStatus == paymentStatusEnum.STATUS_PAID ? "disabled" : ""
            }`}
            searchQuery={serviceSearchQuery}
            search
            fluid
            text={
              selectedService
                ? getServiceItem(selectedService, true)
                : window.APP.LANGUAGE.Pages.Appointment
                    .ServiceDropdownPlaceholder
            }
            onSearchChange={handleServiceSearchChange}
          >
            <Dropdown.Menu>
              {listToRender.map((service) => {
                return (
                  <Dropdown.Item
                    key={service.id}
                    className={`${
                      selectedService.id == service.id ? "hovered" : ""
                    }`}
                    selected={selectedService.id == service.id}
                    onClick={handleSelectService.bind(this, service)}
                  >
                    {getServiceItem(service)}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Txt>
          {closeButton}
        </div>
      );
    };

    return (
      <ReactArrowHandler
        list={listToRender}
        idProperty={"id"}
        textProperty={"name"}
        current={selectedService}
      >
        {getServiceDropdownList()}
      </ReactArrowHandler>
    );
  };

  getStaffDropdown = (
    multiServiceItem,
    multiItemIndex,
    sortedIndex,
    disabled = false
  ) => {
    let {
      selectedStaff,
      loadingTimesForCurrentResourceForClashSection,
      selectedService,
      staffNoPreference,
    } = multiServiceItem;
    let {
      staffList,
      selectedAppointmentStatus,
      appType,
    } = this.props.appointmentStepData;
    let {
      finishedLoadingServicesAndOrganizationData,
      loadingBooking,
      currentBookingId,
      loadingCustomerProfile,
      limitedPermissions,
      advancedAppointmentStepData,
    } = this.props;
    let {
      StaffDropdownPlaceholder,
      StaffDropdownTitle,
    } = window.APP.LANGUAGE.Pages.Appointment;
    let { StaffRequired } = window.APP.LANGUAGE.Errors;
    const selectedLocationId = advancedAppointmentStepData.selectedLocationId;

    if (currentBookingId != multiServiceItem.bookingId) {
      // i am therefore a sibbling
      disabled = true;
      if (this.props[`loadingSibblingBooking_${multiServiceItem.bookingId}`]) {
        loadingBooking = true;
      } else {
        loadingBooking = false;
      }
    } else if (!limitedPermissions.canEditAllBookings) {
      disabled = true; //DES-714
    }

    let selectStaffOption = (staff, dontLoadAvailabilities) => {
      this.updateThisStep(
        {
          selectedStaff: staff,
        },
        multiItemIndex
      );
      if (!dontLoadAvailabilities) {
        this.getDatesAvailableForCurrentStaffOnSelectedDate(
          null,
          staff.id,
          multiServiceItem,
          true
        );
      } else {
        this.getDatesAvailableForCurrentStaffOnSelectedDate(
          null,
          staff.id,
          multiServiceItem
        );
      }
    };

    let getStaffItem = (staff) => {
      if (!staff.name && staffList.length > 0 && staff.id) {
        staff = staffList.find((x) => x.id == staff.id);
        selectStaffOption(staff, true);
      }
      return staff.name || StaffDropdownPlaceholder;
    };

    let isDisabled =
      !finishedLoadingServicesAndOrganizationData ||
      loadingTimesForCurrentResourceForClashSection ||
      loadingBooking ||
      disabled ||
      selectedAppointmentStatus.id == 5 ||
      selectedAppointmentStatus.id == 6 ||
      loadingCustomerProfile;

    //
    // let staffListToRender
    //

    let listToRender =
      currentBookingId && currentBookingId === multiServiceItem.bookingId
        ? staffList.filter((x) => !x.deleted).filter((x) => !x.hidden)
        : selectedService.id
        ? staffList
            .filter((x) => !x.deleted)
            .filter((x) => !x.hidden)
            .filter((x) => x.services.indexOf(selectedService.id) > -1)
        : staffList; //DES-714

    const availableStaff = listToRender
      .map((staff) => {
        const allLocations = staff.locations.map(({ id }) => id);
        return allLocations.includes(+selectedLocationId) && staff;
      })
      .filter((x) => !!x && !x.deleted);

    return (
      <ReactArrowHandler
        list={availableStaff}
        idProperty={"id"}
        textProperty={"name"}
        current={selectedStaff}
      >
        <ValidMe
          defaulttext={StaffDropdownPlaceholder}
          validmemessage={StaffRequired}
          validmefor="dropdown"
          group="firstStepAppointment"
        >
          <Txt
            tabIndex={`${isDisabled ? "-1" : "0"}`}
            type="dropdown"
            disabled={isDisabled}
            openOnFocus={true}
            loading={
              !finishedLoadingServicesAndOrganizationData ||
              loadingTimesForCurrentResourceForClashSection ||
              loadingBooking
            }
            className={`staff-dropdown selection  ${
              selectedStaff.name ? "value-selected" : ""
            } `}
            title={sortedIndex == 0 ? StaffDropdownTitle : ""}
            label={`${
              staffNoPreference
                ? ""
                : appType === "onlinebooking"
                ? "staff-no-preference-label"
                : ""
            }`}
            placeholder={StaffDropdownPlaceholder}
            text={getStaffItem(selectedStaff)}
          >
            <Dropdown.Menu>
              {availableStaff.map((staff) => {
                if (staff.deleted) {
                  return;
                }
                return (
                  <Dropdown.Item
                    key={staff.id}
                    selected={selectedStaff.id == staff.id}
                    className={`${
                      selectedStaff.id == staff.id ? "hovered" : ""
                    }`}
                    onClick={selectStaffOption.bind(this, staff, false)}
                  >
                    {staff.name}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Txt>
        </ValidMe>
      </ReactArrowHandler>
    );
  };

  checkDoubleBookingforDateStaffChange = (item) => {
    setTimeout(() => {
      //we need to execute it in next JS cycle once global state updated.

      //TODO: Not working in staff change. Check logic.
      let {
        currentBookingId,
        loadingBooking,
        appointmentStepData,
        loadingCustomerProfile,
      } = this.props;

      let {
        selectedAppointmentStatus,
        timeList,
        timeSlotsContainingAppointments,
        doubleBookingEnabled,
        unavailableTimeList,
      } = appointmentStepData;

      let bookingWeUpdated = appointmentStepData.multiServiceList.findIndex(
        (x) => x.bookingId == currentBookingId
      );
      let index = 0;
      if (bookingWeUpdated > -1) {
        index = bookingWeUpdated;
      }

      let {
        splitAppointmentFinishTime,
        splitAppointmentBufferTime,
        splitAppointmentFreeTime,
      } = this.props.advancedAppointmentStepData.multiServiceAdvancedList[
        index
      ];
      let {
        selectedDate,
        selectedTime,
        appointmentDuration,
        selectedStaff,
      } = appointmentStepData.multiServiceList[index];

      let totalAppointmentDuration = calculateTotalAppointmentDuration(
        appointmentDuration,
        splitAppointmentFreeTime,
        splitAppointmentFinishTime,
        splitAppointmentBufferTime
      );
      totalAppointmentDuration = totalAppointmentDuration.split(":");
      let totalMinutes =
        parseInt(totalAppointmentDuration[0]) * 60 +
        parseInt(totalAppointmentDuration[1]);
      checkIfNewTimeWillCauseDoubleBooking(
        selectedDate,
        selectedTime,
        selectedTime,
        totalMinutes,
        [selectedTime, ...timeList],
        timeSlotsContainingAppointments,
        this.props.dispatch,
        doubleBookingEnabled,
        unavailableTimeList,
        item,
        selectedStaff
      );
    }, 0);
  };
  getDatePicker = (
    multiServiceItem,
    multiItemIndex,
    sortedIndex,
    disabled = false
  ) => {
    let {
      selectedDate,
      openDatePickerAppointment,
      selectedTime,
      appointmentDuration,
    } = multiServiceItem;
    let {
      currentBookingId,
      loadingBooking,
      appointmentStepData: {
        selectedAppointmentStatus,
        timeList,
        timeSlotsContainingAppointments,
        doubleBookingEnabled,
        unavailableTimeList,
      },
      loadingCustomerProfile,
    } = this.props;
    let {
      splitAppointmentFinishTime,
      splitAppointmentBufferTime,
      splitAppointmentFreeTime,
    } = this.props.advancedAppointmentStepData.multiServiceAdvancedList[
      multiItemIndex
    ];

    disabled = loadingBooking;
    if (currentBookingId != multiServiceItem.bookingId) {
      // i am therefore a sibbling
      disabled = true;
      if (this.props[`loadingSibblingBooking_${multiServiceItem.bookingId}`]) {
        loadingBooking = true;
      } else {
        loadingBooking = false;
      }
    }
    if (!disabled) {
      disabled =
        selectedAppointmentStatus.id == 5 || selectedAppointmentStatus.id == 6;
    }

    if (!disabled) {
      disabled = loadingCustomerProfile;
    }

    let selectDate = (date) => {
      let formattedSelectedDate =
        moment(date).format("YYYY") +
        "-" +
        moment(date).format("MM") +
        "-" +
        moment(date).format("DD") +
        "T" +
        moment(date).format("HH:mm");

      this.updateThisStep(
        {
          selectedDate: formattedSelectedDate,
        },
        multiItemIndex
      );
      this.getDatesAvailableForCurrentStaffOnSelectedDate(
        formattedSelectedDate,
        null,
        multiServiceItem,
        true
      );
    };

    let onBlurDynamicDate = (ev) => {
      let date = ev.target.value;
      if (!moment(date).isValid()) {
        date = moment();
      }
      this.updateThisStep(
        {
          selectedDate:
            moment(date).format("YYYY") +
            "-" +
            moment(date).format("MM") +
            "-" +
            moment(date).format("DD") +
            "T" +
            moment(date).format("HH:mm"),
        },
        multiItemIndex
      );
    };

    let handleDateFocus = () => {
      let open = true;
      this.updateThisStep(
        {
          openDatePickerAppointment: open,
        },
        multiItemIndex
      );
    };

    let handleDateBlur = () => {
      let open = false;
      this.updateThisStep(
        {
          openDatePickerAppointment: open,
        },
        multiItemIndex
      );
    };

    return (
      <div className="field">
        {sortedIndex == 0 ? (
          <h5>{window.APP.LANGUAGE.Pages.Appointment.DateDropdownTitle}</h5>
        ) : (
          ""
        )}
        <ValidMe
          customvalidation={() => {
            return moment(selectedDate).isValid();
          }}
          defaulttext={""}
          validmemessage={window.APP.LANGUAGE.Errors.DateRequired}
          validmefor="dropdown"
          group="firstStepAppointment"
        >
          <DatePicker
            dateFormat="MMM DD, YYYY"
            readOnly
            disabled={disabled}
            selected={moment(selectedDate)}
            className={`booking_date`}
            onChange={selectDate.bind(this)}
            onBlur={onBlurDynamicDate.bind(this)}
            popoverAttachment="bottom left"
            popoverTargetAttachment="top left"
          />
        </ValidMe>
      </div>
    );
  };

  getTimeDropdown = (
    multiServiceItem,
    multiItemIndex,
    sortedIndex,
    disabled = false
  ) => {
    let {
      selectedTime,
      temporarilySelectedTime,
      timeDropdownOpen,
      selectedDate,
      appointmentDuration,
      selectedService,
    } = multiServiceItem;
    let {
      splitAppointmentFinishTime,
      splitAppointmentBufferTime,
      splitAppointmentFreeTime,
    } = this.props.advancedAppointmentStepData.multiServiceAdvancedList[
      multiItemIndex
    ];

    let {
      timeList: timeListTemp,
      selectedAppointmentStatus,
      unavailableTimeList,
      doubleBookingEnabled,
      multiServiceList,
      timeSlotsContainingAppointments,
    } = this.props.appointmentStepData;
    let {
      loadingTimesForCurrentResourceForClashSection,
      currentBookingId,
      loadingBooking,
      loadingCustomerProfile,
    } = this.props;
    let {
      Pages: { Appointment },
      Errors,
    } = window.APP.LANGUAGE;

    if (currentBookingId != multiServiceItem.bookingId) {
      // i am therefore a sibbling
      disabled = true;
      if (this.props[`loadingSibblingBooking_${multiServiceItem.bookingId}`]) {
        loadingBooking = true;
      } else {
        loadingBooking = false;
      }
    }

    // Creating new timeList array
    const timeList = [...timeListTemp];

    let sortAmPmTime = (a, b) => {
      let valueA = a.stringValue;
      let valueB = b.stringValue;
      valueA = parseFloat(valueA, 10);
      valueB = parseFloat(valueB, 10);
      if (valueA > valueB) {
        return 1;
      } else if (valueA < valueB) {
        return -1;
      } else {
        return 0;
      }
    };

    let parseAndFormatEnteredTime = () => {
      let finalValue = temporarilySelectedTime;
      if (finalValue == "" || finalValue == null) return;

      if (!finalValue || !finalValue.trim().split(":")[0]) {
        //ignore times in the format :00
        return;
      }

      finalValue = finalValue.toLowerCase();

      if (finalValue.includes("pm")) {
        let leftValue = finalValue.split(":")[0] || 0;
        leftValue = parseInt(leftValue, 10);
        if (leftValue < 12) leftValue += 12;
        if (leftValue) {
          finalValue =
            leftValue +
            ":" +
            (finalValue.split(":")[1] || "00").replace("pm", "");
        }
      }
      if (finalValue.includes("am")) {
        finalValue = finalValue.replace("am", ""); // ignore am
      }

      if (!finalValue.includes(":")) finalValue += ":00";
      let roundedUpDuration =
        roundUpDurationInFiveMinutesInterval(finalValue) + "";

      let parsedDuration = parseTimeIntervalIntoMinutesAndHours(
        roundedUpDuration
      );

      let pmAmDuration = getAmPmTime(parsedDuration);
      if (temporarilySelectedTime.toLowerCase().includes("am")) {
        // to fix times between 12 - 1 am
        pmAmDuration = pmAmDuration.replace("pm", "am");
      }
      let parsed24hsDuration = get24sTime(pmAmDuration);

      if (parsed24hsDuration.includes("24") && parsed24hsDuration.length == 4) {
        //fix times between 12 - 1 pm
        parsed24hsDuration = parsed24hsDuration.replace("24", "12");
      }
      let timeIsInvalid = false;
      if (parsed24hsDuration == "0") {
        timeIsInvalid = true;
        parsed24hsDuration = "0000";
      }
      if (parsed24hsDuration.length == 3) {
        parsed24hsDuration = "0" + parsed24hsDuration;
      }

      let newTimeItem = "";
      if (timeIsInvalid) {
        newTimeItem = selectedTime;
      } else {
        newTimeItem = {
          value: pmAmDuration,
          stringValue: parsed24hsDuration,
          selected: false,
          disabled: false,
        };
      }

      let updateTime = true;

      let totalAppointmentDuration = calculateTotalAppointmentDuration(
        appointmentDuration,
        splitAppointmentFreeTime,
        splitAppointmentFinishTime,
        splitAppointmentBufferTime
      );
      totalAppointmentDuration = totalAppointmentDuration.split(":");
      let totalMinutes =
        parseInt(totalAppointmentDuration[0]) * 60 +
        parseInt(totalAppointmentDuration[1]);

      if (newTimeItem.stringValue != selectedTime.stringValue) {
        if (timeList.find((x) => x.disabled) != null) {
          // check if there are any disabled times before processing

          let newTimeList = timeList.slice(0);
          newTimeList.push(newTimeItem);

          if (
            !canUserUseThisTimeDueToDoubleBookingDisabled(
              selectedDate,
              selectedTime,
              newTimeItem,
              totalMinutes,
              newTimeList,
              unavailableTimeList,
              this.props.dispatch,
              doubleBookingEnabled
            )
          ) {
            updateTime = false;
          }
        }
      }

      if (updateTime) {
        if (selectedTime.value !== newTimeItem.value) {
          checkIfNewTimeWillCauseDoubleBooking(
            selectedDate,
            selectedTime,
            newTimeItem,
            totalMinutes,
            [newTimeItem, ...timeList],
            timeSlotsContainingAppointments,
            this.props.dispatch,
            doubleBookingEnabled,
            unavailableTimeList,
            multiServiceItem
          );
        }

        if (!timeList.find((time) => time.value == newTimeItem.value)) {
          //only add time to list if it is a new time
          let updatedTimeList = [newTimeItem, ...timeList];
          setTimeout(() => {
            this.updateThisStep({
              timeList: updatedTimeList,
            });
          }, 1); //execute in the next cycle so no other updates step on top of this one
        }
        setTimeout(() => {
          this.updateThisStep(
            {
              selectedTime: newTimeItem,
              temporarilySelectedTime: null,
            },
            multiItemIndex
          );
        }, 1); //execute in next cycle
      } else if (!updateTime) {
        this.updateThisStep(
          {
            temporarilySelectedTime: null,
          },
          multiItemIndex
        );
      }
    };
    let handleBlur = (ev) => {
      this.props.dispatch(
        removeGlobalErrorMessageIfMatchesThisString(
          Errors.TimeNotAvailableKeyword
        )
      );
      parseAndFormatEnteredTime();
      this.updateThisStep(
        {
          timeDropdownOpen: false,
          temporarilySelectedTime: null,
        },
        multiItemIndex
      );

      setTimeout(() => {
        let areThereErrors = forceValidation(
          null,
          null,
          "firstStepAppointment"
        );
      }, 0); //to clear the validation of the selection box
    };
    let handleEnter = (ev) => {
      ev.target.blur();
    };

    let handleTyping = (ev) => {
      this.updateThisStep(
        {
          temporarilySelectedTime: ev.target.value,
        },
        multiItemIndex
      );
    };

    let handleFocus = () => {
      this.updateThisStep(
        {
          timeDropdownOpen: true,
          temporarilySelectedTime: selectedTime.value,
        },
        multiItemIndex
      );
    };

    let selectTime = (time) => {
      this.props.dispatch(
        removeGlobalErrorMessageIfMatchesThisString(
          Errors.TimeNotAvailableKeyword
        )
      );

      let totalAppointmentDuration = calculateTotalAppointmentDuration(
        appointmentDuration,
        splitAppointmentFreeTime,
        splitAppointmentFinishTime,
        splitAppointmentBufferTime
      );
      totalAppointmentDuration = totalAppointmentDuration.split(":");
      let totalMinutes =
        parseInt(totalAppointmentDuration[0]) * 60 +
        parseInt(totalAppointmentDuration[1]);

      this.updateThisStep(
        {
          selectedTime: time,
          timeDropdownOpen: false,
          temporarilySelectedTime: null,
        },
        multiItemIndex
      );

      if (
        timeSlotsContainingAppointments.length == 0 &&
        multiServiceItem.loadedBookingForResourceWithinDates
      ) {
        if (doubleBookingEnabled) {
          this.getDatesAvailableForCurrentStaffOnSelectedDate(
            null,
            null,
            multiServiceItem,
            true
          );
        }
      } else {
        checkIfNewTimeWillCauseDoubleBooking(
          selectedDate,
          selectedTime,
          time,
          totalMinutes,
          timeList,
          timeSlotsContainingAppointments,
          this.props.dispatch,
          doubleBookingEnabled,
          unavailableTimeList,
          multiServiceItem
        );
      }
    };

    let handleTimeOnClick = (e) => {
      let currentTimeObject = findDOMNode(this.timeDropdownRef);

      if (!currentTimeObject.type || currentTimeObject.type != "text")
        currentTimeObject = Array.from(
          currentTimeObject.querySelectorAll("input")
        ).pop();

      if (
        currentTimeObject.type &&
        currentTimeObject.type == "text" &&
        currentTimeObject.value &&
        currentTimeObject.value.length > 0
      ) {
        const colonPos = currentTimeObject.value.indexOf(":");
        if (colonPos > -1) {
          const cursorPos = currentTimeObject.selectionStart;
          if (cursorPos > colonPos) {
            const beforeAmPmPos = currentTimeObject.value.indexOf(" ");
            if (beforeAmPmPos > -1) {
              if (cursorPos < beforeAmPmPos) {
                currentTimeObject.setSelectionRange(
                  colonPos + 1,
                  beforeAmPmPos
                ); // select 00 in 11:00
              } else {
                currentTimeObject.setSelectionRange(
                  beforeAmPmPos + 1,
                  currentTimeObject.value.length
                );
              }
            } else {
              currentTimeObject.setSelectionRange(
                cursorPos,
                currentTimeObject.value.length
              ); // select am/pm in 11:00 pm/am
            }
          } else {
            currentTimeObject.setSelectionRange(0, colonPos); // select 11 in 11:00;
          }
        }
      }
    };

    this.selectedTime = selectedTime;
    let that = this;

    let isDisabled =
      loadingTimesForCurrentResourceForClashSection ||
      disabled ||
      loadingBooking ||
      selectedAppointmentStatus.id == 5 ||
      selectedAppointmentStatus.id == 6 ||
      loadingCustomerProfile;

    if (!isDisabled && multiServiceList && multiServiceList.length > 1) {
      // Sometimes the selectedDate is a moment object and sometimes it's not
      const selectedDateString =
        selectedDate && selectedDate.format
          ? selectedDate.format("YYYYMMDD")
          : moment(selectedDate).format("YYYYMMDD");

      // There is no start time in the data so return
      if (!multiServiceItem.selectedTime.stringValue) {
        return;
      }

      const currentMultiServiceStartTime = apiLocalTimeToMoment(
        `${selectedDateString}T${multiServiceItem.selectedTime.stringValue}00L`
      );
      const currentMultiServiceEndTime = apiLocalTimeToMoment(
        `${selectedDateString}T${multiServiceItem.appointmentEndTimeFromApi.stringValue}00L`
      );
      const firstMultiServiceAppointment = multiServiceList.find(
        (appointment) => {
          return appointment.indexAmongstSibblings === 1;
        }
      );
      const lastMultiServiceAppointment = multiServiceList.find(
        (appointment) => {
          return appointment.indexAmongstSibblings === multiServiceList.length;
        }
      );

      timeList.forEach((timeListItem) => {
        let formattedTimeSlot = `${selectedDateString}T${timeListItem.stringValue}00L`;
        let timeSlot = apiLocalTimeToMoment(formattedTimeSlot);

        // If current appointment, then enable start time
        if (
          timeSlot.isSame(currentMultiServiceStartTime) &&
          timeSlot.thisIsCurrentAppointmentOriginalStartTime
        ) {
          timeListItem.disabled = false;
        }

        const appointmentDuration = multiServiceItem.appointmentDuration;
        let appointmentDurationInMin =
          parseInt(appointmentDuration.split(":")[0]) * 60 +
          parseInt(appointmentDuration.split(":")[1]);

        // If appointment is not the first multi service appointment
        // and the timeslot would overlap the first multi service appointment disable timeslot
        if (
          firstMultiServiceAppointment &&
          firstMultiServiceAppointment.bookingId !==
            multiServiceItem.bookingId &&
          firstMultiServiceAppointment.selectedDate &&
          isInRange(
            apiLocalTimeToMoment(
              `${moment(firstMultiServiceAppointment.selectedDate).format(
                "YYYYMMDD"
              )}T${firstMultiServiceAppointment.selectedTime.stringValue}00L`
            ),
            timeSlot,
            timeSlot.clone().add(appointmentDurationInMin, "m")
          )
        ) {
          timeListItem.disabled = true;
        }

        // If appointment is not the last multi service appointment
        // and the timeslot is for the start time of the last multi service appointment, disable timeslot
        if (
          lastMultiServiceAppointment &&
          lastMultiServiceAppointment.bookingId !==
            multiServiceItem.bookingId &&
          timeSlot.isSame(
            apiLocalTimeToMoment(
              `${moment(lastMultiServiceAppointment.selectedDate).format(
                "YYYYMMDD"
              )}T${lastMultiServiceAppointment.selectedTime.stringValue}00L`
            )
          )
        ) {
          timeListItem.disabled = true;
        }
      });
    }

    return (
      <ReactArrowHandler
        list={timeList}
        idProperty={"index"}
        textProperty={"value"}
        current={selectedTime}
      >
        <ValidMe
          validmevalue={() => {
            return !!that.selectedTime.value;
          }}
          defaulttext={Appointment.TimeDropdownPlaceholder}
          validmemessage={Errors.TimeRequired}
          validmefor="dropdown"
          group="firstStepAppointment"
        >
          <Txt
            ref={(el) => {
              this.timeDropdownRef = el;
            }}
            onClick={handleTimeOnClick}
            open={timeDropdownOpen}
            onFocus={handleFocus}
            searchQuery={
              temporarilySelectedTime != null
                ? temporarilySelectedTime
                : selectedTime.value
            }
            onBlur={handleBlur}
            onSearchChange={handleTyping}
            tabIndex={`${isDisabled ? "-1" : "0"}`}
            loading={loadingTimesForCurrentResourceForClashSection}
            disabled={isDisabled}
            type="dropdown"
            className={`time-dropdown dropdown selection  search ${
              selectedTime.value ? "value-selected" : ""
            }`}
            search
            title={sortedIndex == 0 ? Appointment.TimeDropdownTitle : ""}
            placeholder={Appointment.TimeDropdownPlaceholder}
            text={Appointment.TimeDropdownPlaceholder}
          >
            <Dropdown.Menu>
              {timeList.sort(sortAmPmTime).map((time) => {
                return (
                  <Dropdown.Item
                    disabled={time.disabled}
                    selected={selectedTime.value == time.value}
                    className={`${
                      selectedTime.value == time.value ? "hovered" : ""
                    } ${
                      time.disabled ? "disabled-insensitive" : ""
                    } ${multiItemIndex}`}
                    key={time.value}
                    onClick={selectTime.bind(this, time)}
                  >
                    {time.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Txt>
        </ValidMe>{" "}
      </ReactArrowHandler>
    );
  };

  handleAppUsageMouseIn = () => {
    this.setState({ hoveredAppUsageIcon: true });
  };
  handleAppUsageMouseOut = () => {
    this.setState({ hoveredAppUsageIcon: false });
  };

  handleCustomerAddressMouseIn = () => {
    this.setState({ hoveredCustomerAddress: true });
  };

  handleCustomerAddressMouseOut = () => {
    this.setState({ hoveredCustomerAddress: false });
  };

  handleCustomerUpdate = (visible) => {
    let {
      selectedCustomer,
      customerNameOrPhonenumberSearchQuery,
    } = this.props.appointmentStepData;
    let {
      bookingOnlyCustomerProfileData,
      customerProfileData,
      limitedPermissions,
      currentBookingId,
      appointmentStepData,
    } = this.props;

    const bookingCustomerProfile = {};

    bookingCustomerProfile.email = bookingOnlyCustomerProfileData.email || "";
    bookingCustomerProfile.phoneNumber =
      bookingOnlyCustomerProfileData.phoneNumber || "";
    bookingCustomerProfile.firstName =
      bookingOnlyCustomerProfileData.firstName || "";
    bookingCustomerProfile.lastName =
      bookingOnlyCustomerProfileData.lastName || "";
    bookingCustomerProfile.address =
      bookingOnlyCustomerProfileData.address || {};
    if (bookingCustomerProfile.firstName == "") {
      bookingCustomerProfile.firstName =
        customerNameOrPhonenumberSearchQuery.split(" ")[0] || "";
    }
    if (bookingCustomerProfile.lastName == "") {
      bookingCustomerProfile.lastName =
        customerNameOrPhonenumberSearchQuery.split(" ")[1] || "";
    }

    this.props.dispatch(
      updateBookingOnlyCustomerProfileData(bookingCustomerProfile)
    );

    const newAppointmentStepData = objectAssign({}, appointmentStepData, {
      selectedCustomer: {
        address: bookingOnlyCustomerProfileData.address,
        email: bookingOnlyCustomerProfileData.email,
        firstname: bookingOnlyCustomerProfileData.firstName,
        id: selectedCustomer.id,
        lastname: bookingOnlyCustomerProfileData.lastName,
        phone: bookingOnlyCustomerProfileData.phoneNumber,
      },
      address: bookingCustomerProfile.address,
    });
    this.props.dispatch(updateAppointmentStepData(newAppointmentStepData));

    if (visible) {
      this.props.dispatch(updateBookingCustomerProfileModalVisibility(visible));
    }
  };

  handleChangeOfCustomerSearch = () => {
    let {
      selectedCustomer,
      customerNameOrPhonenumberSearchQuery,
    } = this.props.appointmentStepData;
    let { limitedPermissions } = this.props;

    let searchApiCall = (searchQuery) => {
      if (searchQuery != "") {
        this.props.dispatch(getCustomersBasedOnFilter(searchQuery));
      }
    };

    this.noCustomerSearchPermission = false;
    if (
      customerNameOrPhonenumberSearchQuery &&
      customerNameOrPhonenumberSearchQuery.length > 2
    ) {
      if (limitedPermissions.canSearchForCustomers) {
        setTimeout(() => {
          this.initiatedSearchMode = true; //this cannot be in the state because setState is async and the UI would be out of sync
          this.setState({ searchMode: true }); // to trigger render when this block of code executes after the API which otherwise may not render again with required initiatedSearchMode value.(only happens 1st time)
        }, DEBOUNCED_TIME_IN_MILLISECONDS); //since we  debounced search, this needs to happen so we dont show "no results" right before we show "loading customers in the customer search bar"
        searchApiCall(customerNameOrPhonenumberSearchQuery);
      } else {
        this.noCustomerSearchPermission = true;
        this.initiatedSearchMode = true;
        this.setState({ searchMode: true });
      }
    } else {
      this.initiatedSearchMode = false; //this cannot be in the state because setState is async and the UI would be out of sync
    }
  };

  getCustomerDropdown = () => {
    let {
      CustomerDropdownPlaceholder,
      NoPhoneNumberPlaceholder,
      NoEmailPresentPlaceholder,
      NoPhone,
      NoEmail,
      CustomerFieldPlaceholder,
      CustomerFieldTitle,
    } = window.APP.LANGUAGE.Pages.Appointment;
    let {
      address,
      customerList,
      selectedCustomer,
      customerNameOrPhonenumberSearchQuery,
      appointmentDatabaseCustomerId,
      loadingCustomersList,
      selectedAppointmentStatus,
    } = this.props.appointmentStepData;
    let {
      bookingOnlyCustomerProfileData,
      customerProfileData,
      finishedLoadingServicesAndOrganizationData,
      customerDropdownOpen,
      loadingBooking,
      loadingCustomerProfile,
      limitedPermissions,
    } = this.props;

    let handleCustomerSearchChange = (e, { searchQuery }) => {
      this.updateThisStep({
        customerNameOrPhonenumberSearchQuery: searchQuery,
      });
    };

    let handleCustomerSelection = (selectedCustomer, ev) => {
      window.customerCounter = 0; //DES-817
      let visible = false;
      this.props.dispatch(updateCustomerDropdownVisibility(visible));
      selectedCustomer.notYetSaved = true;
      if (selectedCustomer && selectedCustomer.id) {
        this.dispatchGetCustomerProfileDetails(selectedCustomer.id);
      }

      this.updateThisStep({
        selectedCustomer: selectedCustomer,
        customerNameOrPhonenumberSearchQuery: "", //reset search after selection
      });

      this.props.dispatch(resetCustomerProfileForm());
    };

    let getCustomerItem = (customer) => {
      customer.firstname = customer.firstname || "";
      customer.lastname = customer.lastname || "";

      let fullName = (
        customer.firstname +
        " " +
        customer.lastname
      ).toLowerCase();
      let searchTerm = customerNameOrPhonenumberSearchQuery;
      let beginning = "";
      let ending = "";

      if (fullName.includes(searchTerm) && searchTerm) {
        beginning = fullName.split(searchTerm)[0];
        ending = fullName.split(searchTerm)[1];
      } else {
        beginning = fullName;
        ending = "";
        searchTerm = "";
      }

      if (ending == (customer.lastname || "").toLowerCase()) {
        ending = ending.capitalizeFirstLetter();
      } else if (ending.split(" ").length > 1) {
        ending =
          ending.split(" ")[0] +
          " " +
          ending.split(" ")[1].capitalizeFirstLetter();
      }

      searchTerm = searchTerm.capitalizeFirstLetter();
      return (
        <div className="" key={customer.id}>
          <span className="search_name">
            {beginning.capitalizeFirstLetter()}
            <span className="search_highlight">
              {searchTerm.capitalizeFirstLetter()}
            </span>
            {ending}
          </span>
          <span className="search_secondline">
            <span
              className={`search_email ${customer.email ? "" : "placeholder"}`}
            >
              {customer.email || NoEmail}
            </span>
            <span
              className={`search_phone ${customer.phone ? "" : "placeholder"}`}
            >
              {formatPhone(customer.phone) || NoPhone}
            </span>
          </span>
        </div>
      );
    };

    let getCustomerSelected = () => {
      if (!finishedLoadingServicesAndOrganizationData) {
        return;
      }
      let selectedCustomerEmailInfoElement = "";
      let selectedCustomerPhonenumberInfoElement = "";

      if (bookingOnlyCustomerProfileData.email) {
        selectedCustomerEmailInfoElement = (
          <a
            href={"mailto:" + bookingOnlyCustomerProfileData.email}
            className="booking_email"
          >
            {bookingOnlyCustomerProfileData.email}
          </a>
        );
      } else {
        selectedCustomerEmailInfoElement = (
          <a className="booking_email disabled-insensitive">
            {NoEmailPresentPlaceholder}
          </a>
        );
      }
      if (bookingOnlyCustomerProfileData.phoneNumber) {
        selectedCustomerPhonenumberInfoElement = (
          <span className="booking_phonenumber">
            {formatPhone(bookingOnlyCustomerProfileData.phoneNumber)}
          </span>
        );
      } else {
        selectedCustomerPhonenumberInfoElement = (
          <span className="booking_phonenumber disabled-insensitive">
            {NoPhoneNumberPlaceholder}
          </span>
        );
      }

      return (
        <div className="customer-details ">
          {" "}
          {selectedCustomerEmailInfoElement}{" "}
          {selectedCustomerPhonenumberInfoElement}
        </div>
      );
    };

    let getSelectedCustomerInput = () => {
      return (
        <div className="bold selected-customer-input">
          {(selectedCustomer.firstname || "").capitalizeFirstLetter() +
            " " +
            (selectedCustomer.lastname || "").capitalizeFirstLetter()}
        </div>
      );
    };
    let filterCustomers = () => {
      return customerList;
      // return customerList.filter(o => {
      //   return  searchString(o).includes(customerNameOrPhonenumberSearchQuery.toLowerCase().trim().replace(/-/g,'').replace(/ /g,''));
      // }) //this code was here to remove FALSE/POSITIVES , but now in our backend we get rid of false positives . You can uncomment this in the future if we have false/ positives again
    };

    let handleFocus = () => {
      let visible = true;
      this.props.dispatch(updateCustomerDropdownVisibility(true));
    };

    let handleBlur = () => {
      let visible = false;
      setTimeout(() => {
        this.props.dispatch(updateCustomerDropdownVisibility(visible));
      }, 0);
    };

    let searchString = (customer) => {
      customer.firstname = customer.firstname || "";
      customer.lastname = customer.lastname || "";
      customer.phone = customer.phone || "";
      return (customer.firstname + " " + customer.lastname + customer.phone)
        .toLowerCase()
        .trim()
        .replace(/-/g, "")
        .replace(/ /g, "");
    };

    let getCustomerDrop = () => {
      return (
        <ReactArrowHandler iterateOver={".customer-item"}>
          <Txt
            open={customerDropdownOpen}
            icon="search"
            onFocus={handleFocus}
            type="dropdown"
            loading={
              !finishedLoadingServicesAndOrganizationData ||
              loadingBooking ||
              loadingCustomerProfile
            }
            onBlur={handleBlur}
            disabled={
              !finishedLoadingServicesAndOrganizationData ||
              loadingBooking ||
              loadingCustomerProfile ||
              loadingCustomerProfile
            }
            title={CustomerFieldTitle}
            placeholder={CustomerFieldPlaceholder}
            className="customer-dropdown selection search move-up on-focus-hide"
            closeOnChange={true}
            searchQuery={customerNameOrPhonenumberSearchQuery}
            search
            onInput={this.state.debouncedSearchOfCustomers}
            text={
              selectedCustomer.id ||
              selectedCustomer.email ||
              selectedCustomer.firstname
                ? getSelectedCustomerInput()
                : customerNameOrPhonenumberSearchQuery ||
                  CustomerFieldPlaceholder
            }
            onSearchChange={handleCustomerSearchChange}
          >
            <Dropdown.Menu>
              {customerList.length > 0 ? (
                filterCustomers().map((customer) => {
                  return (
                    <Dropdown.Item
                      key={customer.id}
                      className={`${
                        customer.id == selectedCustomer.id ? "hovered" : ""
                      } customer-item`}
                      selected={customer.id == selectedCustomer.id}
                      onClick={handleCustomerSelection.bind(this, customer)}
                    >
                      {getCustomerItem(customer)}
                    </Dropdown.Item>
                  );
                })
              ) : !loadingCustomersList &&
                customerList.length == 0 &&
                this.initiatedSearchMode &&
                customerNameOrPhonenumberSearchQuery &&
                customerNameOrPhonenumberSearchQuery.length > 2 ? (
                <Dropdown.Item>
                  {this.noCustomerSearchPermission
                    ? window.APP.LANGUAGE.Pages.Appointment
                        .NoCustomerSearchAccess
                    : window.APP.LANGUAGE.Pages.Appointment.NoCustomersFound}
                </Dropdown.Item>
              ) : customerNameOrPhonenumberSearchQuery &&
                customerNameOrPhonenumberSearchQuery.length > 2 ? (
                <Dropdown.Item>
                  <div className="ui active  inline loader tiny"></div>
                  <span className="mrlxs">
                    {
                      window.APP.LANGUAGE.Pages.Appointment
                        .FindingCustomersLabel
                    }
                  </span>
                </Dropdown.Item>
              ) : (
                ""
              )}
            </Dropdown.Menu>
          </Txt>
        </ReactArrowHandler>
      );
    };

    let appIcon = () => {
      let {
        appointmentStepData: { appUsage, appType },
      } = this.props;
      if (appType && appType === "onlinebooking") {
        if (appUsage == "iphone") {
          return (
            <div
              className="ios-icon"
              onMouseOver={this.handleAppUsageMouseIn}
              onMouseOut={this.handleAppUsageMouseOut}
            >
              {this.state.hoveredAppUsageIcon ? (
                <div className="app-icon-box">
                  {" "}
                  <div className="iosbox-icon"></div>Booked with Genbook iOS App
                </div>
              ) : (
                ""
              )}
            </div>
          );
        } else if (appUsage == "android") {
          return (
            <div
              className="android-icon"
              onMouseOver={this.handleAppUsageMouseIn}
              onMouseOut={this.handleAppUsageMouseOut}
            >
              {this.state.hoveredAppUsageIcon ? (
                <div className="app-icon-box">
                  {" "}
                  <div className="androidbox-icon"></div>Booked with Genbook
                  Android App
                </div>
              ) : (
                ""
              )}
            </div>
          );
        } else {
          return (
            <div
              className="online-icon"
              onMouseOver={this.handleAppUsageMouseIn}
              onMouseOut={this.handleAppUsageMouseOut}
            >
              {this.state.hoveredAppUsageIcon ? (
                <div className="online-icon-box">
                  {" "}
                  <div className="online-icon"></div>Booked Online
                </div>
              ) : (
                ""
              )}
            </div>
          );
        }
      }
    };

    let getCustomerAddressSelected = () => {
      if (
        (!customerNameOrPhonenumberSearchQuery && !selectedCustomer.id) ||
        !finishedLoadingServicesAndOrganizationData
      ) {
        return;
      }

      const displayAddress = bookingOnlyCustomerProfileData.address
        ? bookingOnlyCustomerProfileData.address
        : selectedCustomer.address
        ? selectedCustomer.address
        : null;

      if (!displayAddress) {
        return;
      }

      let cityStatePostcode = "";

      if (displayAddress.city) {
        cityStatePostcode = displayAddress.city;
      }

      if (displayAddress.state) {
        cityStatePostcode = cityStatePostcode
          ? `${cityStatePostcode}, ${displayAddress.state}`
          : displayAddress.state;
      }

      if (displayAddress.postalcode) {
        cityStatePostcode = cityStatePostcode
          ? `${cityStatePostcode} ${displayAddress.postalcode}`
          : displayAddress.postalcode;
      }

      return (
        <div className="">
          <div
            className="customer-address-details "
            onMouseOver={this.handleCustomerAddressMouseIn}
            onMouseOut={this.handleCustomerAddressMouseOut}
          >
            <span>{displayAddress.address1 || ""}</span>
            <span>{cityStatePostcode}</span>
          </div>
          {this.state.hoveredCustomerAddress ? (
            <div className="booking_tooltip_text">
              <span>
                {displayAddress.address1}
                {displayAddress.address1 && cityStatePostcode ? ", " : ""}
              </span>
              <span>{cityStatePostcode}</span>
            </div>
          ) : (
            ""
          )}
        </div>
      );
    };

    let elementToReturn = "";

    if (
      appointmentDatabaseCustomerId &&
      bookingOnlyCustomerProfileData &&
      finishedLoadingServicesAndOrganizationData &&
      !selectedCustomer.notYetSaved
    ) {
      let getNameToDisplay = () => {
        return selectedCustomer.id
          ? (bookingOnlyCustomerProfileData.firstName ||
              selectedCustomer.firstname ||
              "") +
              " " +
              (bookingOnlyCustomerProfileData.lastName ||
                selectedCustomer.lastname ||
                "")
          : customerNameOrPhonenumberSearchQuery;
      };
      elementToReturn = (
        <div className="customer-section">
          <div className="field">
            {" "}
            <h5>{CustomerFieldTitle}</h5>
            {appIcon()}
            <div className="customer-name-selected">{getNameToDisplay()}</div>
          </div>{" "}
          {getCustomerSelected()}
          {getCustomerAddressSelected()}
        </div>
      );
    } else {
      elementToReturn = (
        <div className="customer-section">
          {getCustomerDrop()}
          {selectedCustomer.id &&
          finishedLoadingServicesAndOrganizationData &&
          !loadingCustomerProfile ? (
            <button
              tabIndex="-1"
              type="button"
              className="clear_button"
              onClick={handleCustomerSelection.bind(this, {})}
            ></button>
          ) : (
            ""
          )}
          {getCustomerSelected()}
          {getCustomerAddressSelected()}
        </div>
      );
    }

    return elementToReturn;
  };

  setAddressOnClickHandler = () => {
    this.updateTempAppointmentAddress(this.props.appointmentStepData.address);
    this.props.dispatch(updateIsShowingAddressForm(true));
  };

  closeAddressFormOnClickHandler = () => {
    this.updateTempAppointmentAddress(this.props.appointmentStepData.address);
    this.props.dispatch(updateIsShowingAddressForm(false));
  };

  saveAddressFormOnClickHandler = () => {
    this.updateAppointmentDataAddress(this.props.temporaryBookingAddress);
    this.props.dispatch(updateIsShowingAddressForm(false));
  };

  updateAppointmentDataAddress = (addressData) => {
    let newAddressData = objectAssign(
      {},
      this.props.appointmentStepData.address,
      addressData
    );
    this.updateThisStep({ address: newAddressData });
  };

  createReadableAddress = () => {
    let readableAddress = "";
    const appointmentAddress = this.props.appointmentStepData.address;
    let address1Added = false;
    let stateAddressData = "";
    for (const addressParam in this.props.appointmentStepData.address) {
      const addressValue = this.props.appointmentStepData.address[addressParam];
      if (addressValue.length > 0) {
        if (addressParam === "address1") {
          readableAddress = readableAddress.concat(addressValue);
        } else {
          if (stateAddressData.length > 0) {
            stateAddressData = stateAddressData.concat(" ");
          }
          stateAddressData = stateAddressData.concat(addressValue);
        }
      }
    }
    if (readableAddress.length > 0 && stateAddressData.length > 0) {
      readableAddress = readableAddress.concat(", ");
    }
    readableAddress = readableAddress.concat(stateAddressData);
    return readableAddress;
  };

  updateTempAppointmentAddress = (data) => {
    let newAddressData = objectAssign(
      {},
      this.props.temporaryBookingAddress,
      data
    );
    this.props.dispatch(updatetemporaryBookingAddress(newAddressData));
  };

  changeTempAddress1Handler = (addressValue) => {
    this.updateTempAppointmentAddress({ address1: addressValue });
  };

  changeTempCityHandler = (cityValue) => {
    this.updateTempAppointmentAddress({ city: cityValue });
  };

  changeTempStateHandler = (selectedState) => {
    this.updateTempAppointmentAddress({ state: selectedState });
  };

  changeTempPostalCodeHandler = (postalcodeValue) => {
    this.updateTempAppointmentAddress({ postalcode: postalcodeValue });
  };

  clearAddressForm = () => {
    this.props.dispatch(clearAddressFormInAppointmentStep());
  };
  getCustomerAddressForm = () => {
    let {
      AddressFormTitle,
      SaveAddress,
      ClearAddress,
    } = window.APP.LANGUAGE.Pages.Appointment;
    let { temporaryBookingAddress } = this.props;
    let clearAddressButtonClasses = "clear_address_button";

    if (!this.props.isShowingAddressForm) {
      return "";
    }
    if ((temporaryBookingAddress.address1 || "").length == 0) {
      clearAddressButtonClasses += " disabled-insensitive";
    }
    return (
      <Dimmer
        active={this.props.isShowingAddressForm}
        inverted
        className="address_form_overlay"
      >
        <div className="ui appointment_address_form">
          <div className="address_form_header">
            <div className="address_icon" />
            <button
              type="button"
              className="close_button address_form_close"
              onClick={this.closeAddressFormOnClickHandler}
            ></button>
          </div>
          <div className="address_input field">
            <h5>{AddressFormTitle}</h5>
            <AddressForm
              addressValue={temporaryBookingAddress}
              addressChangeHandler={this.changeTempAddress1Handler}
              cityChangeHandler={this.changeTempCityHandler}
              postalCodeChangeHandler={this.changeTempPostalCodeHandler}
              stateChangeHandler={this.changeTempStateHandler}
            />
          </div>
          <div className="address_form_footer">
            <a
              className={clearAddressButtonClasses}
              onClick={this.clearAddressForm}
            >
              {ClearAddress}
            </a>
            <a
              className="save_address_button"
              onClick={this.saveAddressFormOnClickHandler}
            >
              {SaveAddress}
            </a>
          </div>
        </div>
      </Dimmer>
    );
  };

  formatParsedDurations = (parsedDuration) => {
    let {
      HourAbbreviated,
      MinuteAbbreviated,
      HoursAbbreviated,
    } = window.APP.LANGUAGE;

    let formattedDurationParts = (parsedDuration = parsedDuration.split(":"));
    if (formattedDurationParts[0] != "00") {
      if (formattedDurationParts.length > 1) {
        if (parseInt(formattedDurationParts[0]) > 1)
          formattedDurationParts[0] += HoursAbbreviated;
        else formattedDurationParts[0] += HourAbbreviated;
      } else {
        formattedDurationParts[0] += MinuteAbbreviated;
      }
    } else formattedDurationParts[0] = "";

    formattedDurationParts[1] = formattedDurationParts[1]
      ? formattedDurationParts[1] + MinuteAbbreviated
      : "";

    if (formattedDurationParts[0].indexOf("0") == 0) {
      formattedDurationParts[0] = formattedDurationParts[0].replace("0", "");
    }

    return formattedDurationParts.join(" ");
  };

  calculateAppointmentTotalDuration = (multiServiceItem, multiItemIndex) => {
    let { multiServiceAdvancedList } = this.props.advancedAppointmentStepData;

    let {
      splitAppointmentFinishTime,
      splitAppointmentBufferTime,
      splitAppointmentFreeTime,
    } = multiServiceAdvancedList[multiItemIndex];
    let { appointmentDuration, selectedService } = multiServiceItem;
    let parsedDuration = "";

    if (
      appointmentDuration &&
      (splitAppointmentFreeTime != "" ||
        splitAppointmentFinishTime != "" ||
        splitAppointmentBufferTime != "")
    ) {
      parsedDuration = calculateTotalAppointmentDuration(
        appointmentDuration,
        splitAppointmentFreeTime,
        splitAppointmentFinishTime,
        splitAppointmentBufferTime
      );
      if (parsedDuration == "")
        parsedDuration = appointmentDuration || selectedService.duration || "";
    } else {
      parsedDuration = appointmentDuration || selectedService.duration || "";
    }

    return parsedDuration;
  };

  calculateMultipleAppointmentsTotalDuration = () => {
    let { multiServiceList } = this.props.appointmentStepData;
    let { multiServiceAdvancedList } = this.props.advancedAppointmentStepData;

    let durationsForEachAppointment = multiServiceList.map(
      (multiServiceItem, multiItemIndex) => {
        if (multiItemIndex < multiServiceAdvancedList.length) {
          return this.calculateAppointmentTotalDuration(
            multiServiceItem,
            multiItemIndex
          );
        }
      }
    );
    let aggregatedMultipleDurations = addMultipleAppointmentDurations(
      durationsForEachAppointment
    );
    let parsedDurationsToDisplay = this.formatParsedDurations(
      aggregatedMultipleDurations
    );
    return parsedDurationsToDisplay;
  };

  getDurationInput = (
    multiServiceItem,
    multiItemIndex,
    sortedIndex,
    disabled = false
  ) => {
    let { appointmentDuration } = multiServiceItem;
    let {
      loadingBooking,
      finishedLoadingServicesAndOrganizationData,
      currentBookingId,
      appointmentStepData: { selectedAppointmentStatus },
      loadingCustomerProfile,
    } = this.props;
    let {
      DurationFieldTitle,
      DurationFieldPlaceholder,
    } = window.APP.LANGUAGE.Pages.Appointment;
    let { multiServiceAdvancedList } = this.props.advancedAppointmentStepData;

    let {
      splitAppointmentFinishTime,
      splitAppointmentBufferTime,
      splitAppointmentFreeTime,
    } = multiServiceAdvancedList[multiItemIndex];

    if (currentBookingId != multiServiceItem.bookingId) {
      // i am therefore a sibbling
      disabled = true;
      if (this.props[`loadingSibblingBooking_${multiServiceItem.bookingId}`]) {
        loadingBooking = true;
      } else {
        loadingBooking = false;
      }
    }

    let handleDurationChange = (ev) => {
      if (ev.target.value !== ":") {
        let finalValue = ev.target.value.replace(/[^0-9.:]/g, "");

        this.updateThisStep(
          {
            appointmentDuration: finalValue,
          },
          multiItemIndex
        );
      }
    };

    let handleDurationBlur = () => {
      if (appointmentDuration && appointmentDuration.length > 0) {
        let roundedUpDuration = roundUpDurationInFiveMinutesInterval(
          appointmentDuration
        );
        let parsedDuration = parseTimeIntervalIntoMinutesAndHours(
          roundedUpDuration + ""
        );

        if (parsedDuration == "") parsedDuration = MINIMUM_APPOINTMENT_TIME; //minimum appointment time

        this.updateThisStep(
          {
            appointmentDuration: parsedDuration,
          },
          multiItemIndex
        );

        if (parsedDuration !== multiServiceItem.appointmentDuration) {
          this.getDatesAvailableForCurrentStaffOnSelectedDate(
            null,
            null,
            multiServiceItem,
            true
          );
        }
      }
    };

    let isDisabled =
      loadingBooking ||
      !finishedLoadingServicesAndOrganizationData ||
      disabled ||
      selectedAppointmentStatus.id == 5 ||
      selectedAppointmentStatus.id == 6 ||
      loadingCustomerProfile;

    if (splitAppointmentFreeTime != "" || splitAppointmentFinishTime != "") {
      return (
        <Txt
          title={sortedIndex == 0 ? DurationFieldTitle : ""}
          className="duration-input split-duration"
          type="input"
          tabIndex={`${isDisabled ? "-1" : "0"}`}
        >
          <a
            onClick={this.gotToAdvancedTabForSplitAppointment.bind(
              this,
              menuNamesEnum.SECOND_STEP_ADVANCED
            )}
            className="split-link"
          >
            &nbsp;&nbsp;Split
          </a>
        </Txt>
      );
    }

    return (
      <ValidMe
        validmemessage={window.APP.LANGUAGE.Errors.DurationRequired}
        validmefor="condition&required"
        group="firstStepAppointment"
        condition={(value) => {
          return value !== ":" && value.length > 0;
        }}
        validmemessagecondition={window.APP.LANGUAGE.Errors.DurationRequired}
      >
        <Txt
          disabled={isDisabled}
          onClick={(ev) => ev.target.select()}
          tabIndex={`${isDisabled ? "-1" : "0"}`}
          className="duration-input"
          type="input"
          onBlur={handleDurationBlur}
          onChange={handleDurationChange}
          title={sortedIndex == 0 ? DurationFieldTitle : ""}
          placeholder={DurationFieldPlaceholder}
          value={appointmentDuration}
        ></Txt>
      </ValidMe>
    );
  };

  getCostInput = (
    multiServiceItem,
    multiItemIndex,
    sortedIndex,
    disabled = false
  ) => {
    let { selectedService } = multiServiceItem;
    let {
      loadingBooking,
      finishedLoadingServicesAndOrganizationData,
      currentBookingId,
      appointmentStepData: { selectedAppointmentStatus, paymentStatus },
      loadingCustomerProfile,
      bookingChannel,
    } = this.props;

    let {
      Pages: { AppointmentAdvanced },
      Errors,
    } = window.APP.LANGUAGE;
    let { offerId } = this.props.advancedAppointmentStepData;

    if (currentBookingId != multiServiceItem.bookingId) {
      // i am therefore a sibbling
      disabled = true;
      if (this.props[`loadingSibblingBooking_${multiServiceItem.bookingId}`]) {
        loadingBooking = true;
      } else {
        loadingBooking = false;
      }
    }

    if (!disabled) {
      disabled =
        selectedAppointmentStatus.id == 5 || selectedAppointmentStatus.id == 6;
    }

    let handleServicePriceChange = (ev, reactEv, hardValue) => {
      let value = hardValue || ev.target.value;
      value = value.replace(window.APP.LANGUAGE.Currency, "");
      value = value.replace(/[^0-9.:]/g, "");

      if (value.includes(".")) {
        value = value.split(".")[0] + "." + value.split(".")[1].substring(0, 2);
      }

      if (!value) {
        value = 0;
      } else {
        while (value.length > 1 && value.charAt(0) === "0") {
          value = value.substr(1);
        }
      }

      let copy = clone(selectedService);
      copy.price = value;

      this.updateThisStep(
        {
          selectedService: copy,
        },
        multiItemIndex
      );
    };

    let disabledPrice =
      loadingBooking ||
      !finishedLoadingServicesAndOrganizationData ||
      disabled ||
      !!offerId ||
      (bookingChannel && !!bookingChannel.name) ||
      paymentStatus == paymentStatusEnum.STATUS_PAID ||
      loadingCustomerProfile; //|| paymentStatus == paymentStatusEnum.STATUS_PARTIAL DES-771
    return (
      <div className="ui pdbnull cost-section">
        <Txt
          type="input"
          tabIndex={`${disabled ? "-1" : "0"}`}
          className={`cost-input ${
            selectedService.price !== 0 ? "" : "cost-zero"
          }`}
          disabled={disabledPrice}
          onChange={handleServicePriceChange}
          placeholder={AppointmentAdvanced.ServicePricePlaceholder}
          value={window.APP.LANGUAGE.Currency + (selectedService.price || 0)}
          title={sortedIndex == 0 ? AppointmentAdvanced.ServicePriceTitle : ""}
        ></Txt>
      </div>
    );
  };

  getAddMultiServiceItemButton = () => {
    let { multiServiceList } = this.props.appointmentStepData;
    let { AddServiceButton } = window.APP.LANGUAGE.Pages.Appointment;
    let { multiServiceAdvancedList } = this.props.advancedAppointmentStepData;

    let addMultiServiceItem = () => {
      multiServiceList.push(initialServiceWithDefaultData());
      multiServiceAdvancedList.push(initialAdvancedServiceWithDefaultData());
      this.updateThisStep({
        multiServiceList: multiServiceList,
        multiServiceAdvancedList: multiServiceAdvancedList,
      });
    };
    let buttonClasses = "add-service";
    if (multiServiceList.length >= 3) {
      buttonClasses += " disabled-insensitive";
    }
    return (
      <div>
        <a className={buttonClasses} onClick={addMultiServiceItem}>
          <span>+</span>&nbsp;{AddServiceButton}
        </a>
      </div>
    );
  };

  getRemoveServiceButton = (
    multiServiceItem,
    multiItemIndex,
    disabled = false
  ) => {
    let {
      multiServiceList,
      selectedAppointmentStatus,
    } = this.props.appointmentStepData;
    let {
      loadingBooking,
      currentBookingId,
      loadingCustomerProfile,
    } = this.props;
    let { multiServiceAdvancedList } = this.props.advancedAppointmentStepData;
    let { AddServiceButton } = window.APP.LANGUAGE.Pages.Appointment;

    if (currentBookingId != multiServiceItem.bookingId) {
      // i am therefore a sibbling
      disabled = true;
      if (this.props[`loadingSibblingBooking_${multiServiceItem.bookingId}`]) {
        loadingBooking = true;
      } else {
        loadingBooking = false;
      }
    }
    if (!disabled) {
      disabled =
        selectedAppointmentStatus.id == 5 || selectedAppointmentStatus.id == 6;
    }

    if (!disabled) {
      disabled = loadingCustomerProfile;
    }

    let removeMultiServiceItem = () => {
      multiServiceList.splice(multiItemIndex, 1);
      multiServiceAdvancedList.splice(multiItemIndex, 1);
      this.updateThisStep({
        multiServiceList: multiServiceList,
        multiServiceAdvancedList: multiServiceAdvancedList,
      });
    };
    let classes = "ui icon trash";
    if (multiServiceList.length == 1 || disabled) {
      classes += " disabled-insensitive";
    }
    return (
      <i
        className={classes}
        tabIndex={`${disabled ? "-1" : false}`}
        onClick={removeMultiServiceItem}
      ></i>
    );
  };

  canEditCurrentBooking = () => {
    let { limitedPermissions, currentBookingId } = this.props;
    return (
      limitedPermissions.canEditAllBookings ||
      (limitedPermissions.bookingsEditableByCurrentUser.indexOf(
        currentBookingId
      ) > -1 &&
        currentBookingId)
    );
  };

  modifyBookingFormCustomer = () => {
    let {
      selectedCustomer,
      customerNameOrPhonenumberSearchQuery,
    } = this.props.appointmentStepData;
    let {
      bookingOnlyCustomerProfileData,
      customerProfileData,
      limitedPermissions,
      currentBookingId,
      appointmentStepData,
    } = this.props;

    const bookingCustomerProfle = {};

    bookingCustomerProfle.email =
      selectedCustomer.email || customerProfileData.email || "";
    bookingCustomerProfle.phoneNumber =
      selectedCustomer.phone || customerProfileData.phoneNumber || "";
    bookingCustomerProfle.firstName =
      selectedCustomer.firstname || customerProfileData.firstName || "";
    bookingCustomerProfle.lastName =
      selectedCustomer.lastname || customerProfileData.lastName || "";
    bookingCustomerProfle.address = selectedCustomer.address || {};
    if (bookingCustomerProfle.firstName == "") {
      bookingCustomerProfle.firstName =
        customerNameOrPhonenumberSearchQuery.split(" ")[0] || "";
    }
    if (bookingCustomerProfle.lastName == "") {
      bookingCustomerProfle.lastName =
        customerNameOrPhonenumberSearchQuery.split(" ")[1] || "";
    }

    let canCreateCustomerByUsingBookingFormFields =
      limitedPermissions.canCreateCustomerProfile &&
      limitedPermissions.canSearchForCustomers &&
      (this.canEditCurrentBooking() || !currentBookingId);

    if (canCreateCustomerByUsingBookingFormFields) {
      bookingCustomerProfle.address = appointmentStepData.address;
    }

    //TODO WORK HERE : SHOW CUSTOMER PROFILE DATA IF CANNOT EDIT BUT CAN VIEW
    this.props.dispatch(
      updateBookingOnlyCustomerProfileData(bookingCustomerProfle)
    );
    this.dispatchUpdateCurrentMenu(
      menuNamesEnum.INTERMEDIATE_STEP_BOOKING_ONLY_CUSTOMER_PROFILE
    );
  };

  resetCustomerProfileForm = () => {
    this.props.dispatch(resetCustomerProfileForm());
  };

  addNewCustomer = (whereToGo) => {
    let {
      selectedCustomer,
      customerNameOrPhonenumberSearchQuery,
    } = this.props.appointmentStepData;

    if (
      whereToGo == menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_PROFILE_CREATE ||
      !selectedCustomer.id
    ) {
      this.resetCustomerProfileForm();
    }
    setTimeout(() => {
      if (!selectedCustomer.id) {
        let customerData = {
          firstName: customerNameOrPhonenumberSearchQuery.split(" ")[0] || "",
          lastName: customerNameOrPhonenumberSearchQuery.split(" ")[1] || "",
          email: selectedCustomer.email || "",
          phoneNumber: selectedCustomer.phone || "",
          address: selectedCustomer.address || {},
        };
        let newData = objectAssign(
          {},
          this.props.customerProfileData,
          customerData
        );
        this.props.dispatch(updateCustomerProfileData(newData));
      }
      this.dispatchUpdateCurrentMenu(whereToGo);
    }, 0);
  };

  gotToAdvancedTabForSplitAppointment = (whereToGo) => {
    this.dispatchUpdateCurrentMenu(whereToGo);
  };

  getAddressField = (disabled) => {
    let { multiServiceList } = this.props.appointmentStepData;
    const {
      SetAddressLink,
      AddressLinkTitle,
    } = window.APP.LANGUAGE.Pages.Appointment;

    let appointmentAddressLink = this.createReadableAddress();
    if (appointmentAddressLink.length === 0) {
      appointmentAddressLink = SetAddressLink;
    }
    let elementToReturn = "";
    if (
      multiServiceList[0] &&
      multiServiceList[0].selectedService.requireaddress
    ) {
      elementToReturn = (
        <div className="appointment_address fade-right-animation">
          <h5>
            {AddressLinkTitle}
            <span
              className={`set_address ${
                disabled ? " disabled-insensitive" : ""
              }`}
              onClick={this.setAddressOnClickHandler}
            >
              {appointmentAddressLink}
            </span>
          </h5>
        </div>
      );
    }

    return elementToReturn;
  };

  handleNoAccessMouseIn = () => {
    this.setState({ hoveredNoAccessToolTip: true });
  };
  handleNoAccessMouseOut = () => {
    this.setState({ hoveredNoAccessToolTip: false });
  };

  getBookingRowsWithoutAccess = () => {
    let {
      MultiServiceNoAccessMessage,
      MultiServiceNoAccessToolTipMsg,
    } = window.APP.LANGUAGE.Pages.Appointment;

    return (
      <div className="no-access-row">
        <div className="no-access-service-container">
          {MultiServiceNoAccessMessage}&nbsp;
          <span
            className="booking_tooltip no-access"
            onMouseOver={this.handleNoAccessMouseIn}
            onMouseOut={this.handleNoAccessMouseOut}
          ></span>
          {this.state.hoveredNoAccessToolTip ? (
            <div className="booking_tooltip_text">
              {MultiServiceNoAccessToolTipMsg}
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="no-access-cost-section">--</div>
        <div className="no-access-staff-container">--</div>
        <div className="no-access-date-container">--</div>
        <div className="no-access-time-container">--</div>
        <div className="no-access-duration-container">--</div>
      </div>
    );
  };

  getBottomSection = () => {
    let {
      currentBookingId,
      appointmentStepData: {
        appointmentNotes,
        paymentStatus,
        clientSpecialRequestComments,
        showMemoFullView,
        showNotesFullView,
        selectedAppointmentStatus,
      },
      limitedPermissions,
      gotValidOffer,
      loadingCustomerProfile,
    } = this.props;
    const {
      Pages: { Appointment },
      Currency,
    } = window.APP.LANGUAGE;
    const MAX_APPOINTMENT_CHARACTERS = 255;
    const MAX_CLIENT_SPECIAL_REQUEST_COMMENTS = 255;
    let disabled = false;
    if (
      !limitedPermissions.canEditAllBookings &&
      limitedPermissions.bookingsEditableByCurrentUser.indexOf(
        currentBookingId
      ) < 0 &&
      currentBookingId
    ) {
      disabled = true;
    }
    if (!disabled) {
      disabled = selectedAppointmentStatus.id == 5;
    }

    if (!disabled) {
      disabled = loadingCustomerProfile;
    }

    let getAppointmentCharacterCountValue = () => {
      return (
        <span className="char-number">
          {appointmentNotes.length}/{MAX_APPOINTMENT_CHARACTERS}
        </span>
      );
    };
    let getClientSpecialRequestCommentsCountValue = () => {
      return (
        <span className="char-number">
          {clientSpecialRequestComments.length}/
          {MAX_CLIENT_SPECIAL_REQUEST_COMMENTS}
        </span>
      );
    };

    let calculateAppointmentTotalCost = () => {
      return Currency + (selectedService.price || "0");
    };

    let getPaymentStatusBox = () => {
      let elementToReturn = "";
      if (limitedPermissions.canViewAndEditCheckoutInvoicesForAllBookings) {
        if (paymentStatus == paymentStatusEnum.STATUS_PAID || gotValidOffer) {
          elementToReturn = (
            <div className="appointment-summary payment-status-box _paid">
              {Appointment.PaymentStatusPaid}
            </div>
          );
        } else if (paymentStatus == paymentStatusEnum.STATUS_PARTIAL) {
          elementToReturn = (
            <div className="appointment-summary payment-status-box _unpaid">
              {Appointment.PaymentStatusPartial}
            </div>
          );
        } else if (
          (paymentStatus == paymentStatusEnum.STATUS_UNPAID ||
            paymentStatus == paymentStatusEnum.STATUS_UNKNOWN) &&
          currentBookingId
        ) {
          elementToReturn = (
            <div className="appointment-summary payment-status-box _unpaid">
              {Appointment.PaymentStatusUnpaid}
            </div>
          );
        } else {
          elementToReturn = (
            <div className="appointment-summary payment-status-box _unknown">
              {Appointment.PaymentStatusUnpaid}
            </div>
          );
        }
      }
      return elementToReturn;
    };

    let memosClickHandler = (show) => {
      this.updateThisStep({
        showMemoFullView: show,
      });
    };

    let notesClickHandler = (show) => {
      this.updateThisStep({
        showNotesFullView: show,
      });
    };

    let getClientSpecialRequestCommentsFullView = () => {
      let elementToReturn = "";

      if (showMemoFullView) {
        elementToReturn = (
          <div className="full-view-container ">
            <i className={`comment-icon`}></i>
            <Txt
              disabled={true}
              fieldclasses="memos-full-view "
              type="textarea"
              rows="4"
              cols="60"
              className="booking_notes memos-full-view-textarea color-disabled-bg"
              onChange={(ev) =>
                this.updateThisStep({
                  clientSpecialRequestComments: ev.target.value,
                })
              }
              maxLength={MAX_CLIENT_SPECIAL_REQUEST_COMMENTS}
              placeholder={Appointment.ClientSpecialRequestCommentsPlaceholder}
              value={clientSpecialRequestComments}
            ></Txt>
            <div className="bottom">
              <span>&nbsp;</span>
              <a
                onClick={memosClickHandler.bind(this, false)}
                className="close"
              >
                {Appointment.CloseEditMemos}
              </a>
            </div>
          </div>
        );
      }
      return elementToReturn;
    };

    let getAppointmentNotesFullView = () => {
      let elementToReturn = "";

      if (showNotesFullView) {
        elementToReturn = (
          <div
            className={`full-view-container ${
              clientSpecialRequestComments.length != 0
                ? "align-with-special-request"
                : ""
            }`}
          >
            <i className={`sticky-note-icon`}></i>
            <Txt
              autoFocus
              disabled={disabled}
              fieldclasses="notes-full-view"
              onBlur={notesClickHandler.bind(this, false)}
              type="textarea"
              rows="2"
              cols="60"
              className="booking_notes notes-full-view-textarea"
              onChange={(ev) =>
                this.updateThisStep({ appointmentNotes: ev.target.value })
              }
              maxLength={MAX_APPOINTMENT_CHARACTERS}
              placeholder={Appointment.AppointmentNotesFieldPlaceholder}
              value={appointmentNotes}
            ></Txt>
            <div className="bottom">
              <span>
                <a
                  onClick={notesClickHandler.bind(this, false)}
                  className="close"
                >
                  {Appointment.CloseEditNotes}
                </a>
              </span>
            </div>
          </div>
        );
      }
      return elementToReturn;
    };

    let memosTrigger = (
      <span>
        <i className={`comment-icon`}></i>
        <span
          className={`${
            clientSpecialRequestComments.length == 0
              ? "color-placeholder"
              : "icon-padding"
          }`}
        >
          {clientSpecialRequestComments ||
            Appointment.ClientSpecialRequestComments}
        </span>
      </span>
    );
    let notesTrigger = (
      <span>
        <i className={`sticky-note-icon`}></i>
        <span
          className={`${
            appointmentNotes.length == 0
              ? "color-placeholder icon-padding"
              : "icon-padding"
          }`}
        >
          {appointmentNotes || Appointment.AppointmentNotesFieldPlaceholder}
        </span>
      </span>
    );

    return (
      <div className="appointment-bottom-section">
        <div className="appointment-bottom-no-address">
          <div className="notes-and-memos ">
            {clientSpecialRequestComments.length != 0 &&
            !showMemoFullView &&
            !showNotesFullView ? (
              <Txt
                trigger={memosTrigger}
                fieldclasses="no-field"
                type="dropdown"
                onClick={memosClickHandler.bind(this, true)}
                onFocus={memosClickHandler.bind(this, true)}
                className={`memos selection on-focus-hide`}
              ></Txt>
            ) : (
              ""
            )}
            {!showNotesFullView && !showMemoFullView ? (
              <Txt
                trigger={notesTrigger}
                fieldclasses="no-field"
                type="dropdown"
                onClick={notesClickHandler.bind(this, true)}
                onFocus={notesClickHandler.bind(this, true)}
                className={`notes selection on-focus-hide`}
              ></Txt>
            ) : (
              ""
            )}
            {getClientSpecialRequestCommentsFullView()}
            {getAppointmentNotesFullView()}
          </div>
          <div className="appointment-notes">{getPaymentStatusBox()}</div>
        </div>
      </div>
    );
  };

  closeSquareOffline = () => {
    this.setState({
      showOfflineModal: false,
    });
  };

  closeApptModal = () => {
    document.getElementsByClassName("close_button2")[0].click();
  };

  getServicesList = (
    multiServiceList,
    sibblingBookingsTotalStartingFromZero
  ) => {
    // Currently for multiservice appointments, the application fires the same action to get the services
    // Due to this the saga uses takeEvery. For some unknown reason the application will fire the same request
    // multiple times which results in the list of services having duplicates.
    // As such for now we just filter out duplicates. This is a bandaid fix as code was updated to prevent infinite loop issue
    // + previous code with infinite loop still fired the same amount of duplicate apis
    const list = getFinalListOfServicesWithAccessAndNoAccess(
      multiServiceList,
      sibblingBookingsTotalStartingFromZero
    ).sort((a, b) => {
      return a.indexAmongstSibblings - b.indexAmongstSibblings;
    });

    const noDuplicatesArray = list.reduce((acc, current) => {
      const x = acc.find(
        (item) => item.indexAmongstSibblings === current.indexAmongstSibblings
      );
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);

    return noDuplicatesArray;
  };
  render() {
    let { staffList, multiServiceList } = this.props.appointmentStepData;
    const {
      AddCustomerButton,
      AddressLinkTitle,
      AppointmentNotesFieldPlaceholder,
      CustomerProfileButton,
      CustomerProfileButtonNoAccess,
      Edit,
    } = window.APP.LANGUAGE.Pages.Appointment;
    let {
      appointmentDuration,
      customerNameOrPhonenumberSearchQuery,
      selectedAppointmentStatus,
      selectedService,
      selectedCustomer,
    } = this.props.appointmentStepData;
    const {
      currentBookingId,
      limitedPermissions,
      sibblingBookingsTotalStartingFromZero,
      finishedLoadingSibblingBookings,
      loadingCustomerProfile,
      loadingBooking,
    } = this.props;

    let setAddressVisibilityStyle = { visibility: "hidden" };
    if (
      multiServiceList[0].selectedService &&
      multiServiceList[0].selectedService.requireaddress
    ) {
      setAddressVisibilityStyle = { visibility: "visible" };
    }

    let customerProfileButton = (
      <a className="customer-profile-button disabled disabled-insensitive">
        {CustomerProfileButton}
      </a>
    );
    let customerAddButton = (
      <a className="add-customer disabled-insensitive">
        <span>+</span>&nbsp;{AddCustomerButton}
      </a>
    );

    if (!limitedPermissions.canViewCustomerProfile && !loadingCustomerProfile) {
      // Leave as disabled button if user doesn't have access to view customer profile
    } else if (
      selectedCustomer.id &&
      !loadingCustomerProfile &&
      limitedPermissions.canCreateCustomerProfile
    ) {
      customerProfileButton = (
        <a
          onClick={this.addNewCustomer.bind(
            this,
            menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_PROFILE_EDIT
          )}
          className={
            selectedCustomer && selectedCustomer.id
              ? "customer-profile-button"
              : "customer-profile-button disabled disabled-insensitive"
          }
        >
          {CustomerProfileButton}
        </a>
      );
    }

    if (
      (!limitedPermissions.canCreateCustomerProfile ||
        !limitedPermissions.canViewCustomerProfile ||
        !limitedPermissions.canEditCustomerProfile) &&
      !selectedCustomer.id &&
      !loadingBooking
    ) {
      customerAddButton = (
        <a onClick={this.modifyBookingFormCustomer} className="add-customer">
          <span>+</span>&nbsp;{AddCustomerButton}
        </a>
      );
    } else if (!selectedCustomer.id && !loadingBooking) {
      customerAddButton = (
        <a
          onClick={this.addNewCustomer.bind(
            this,
            menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_PROFILE_CREATE
          )}
          className={
            selectedCustomer && selectedCustomer.id
              ? "disabled-insensitive add-customer"
              : "add-customer"
          }
        >
          <span>+</span>&nbsp;{AddCustomerButton}
        </a>
      );
    }

    let multiServiceIndex = 0;

    let getBookingCustomerUpdate = () => {
      // Don't show edit button if a customer profile doesn't exist
      // and if the booking hasn't been created.
      // There's probably a better way to check that the booking hasn't been created yet
      if (
        (!selectedCustomer.id || !customerNameOrPhonenumberSearchQuery) &&
        selectedAppointmentStatus &&
        !selectedAppointmentStatus.id
      ) {
        return;
      }

      return (
        <a
          className="booking_customer_edit"
          tabIndex="0"
          onClick={() => this.handleCustomerUpdate(true)}
        >
          {Edit}
        </a>
      );
    };

    return (
      <div className="tabpane">
        {this.props.offlineSquarePayment && this.state.showOfflineModal && (
          <div className="square-offline-warning">
            <p>
              A payment for this booking was completed but the Genbook invoice
              was not updated.
            </p>
            <p>
              {" "}
              Please check your Square transactions before processing additional
              payments against this booking.
            </p>
            <div className="offline-warning__button">
              <span onClick={this.closeApptModal}>Cancel</span>
              <span onClick={this.closeSquareOffline}>Proceed</span>
            </div>
          </div>
        )}
        {this.getCustomerAddressForm()}
        <div className="ui form">
          <div className="customer-info top-section two fields">
            <div className="ui customer-info-section">
              {this.getCustomerDropdown()}
              <div className="customer-profile-add">
                {customerAddButton}
                {customerProfileButton}
                {getBookingCustomerUpdate()}
              </div>
            </div>
            {this.getStatusDropdown()}
            {this.isCustomerBlocked()}
          </div>
          <div className="appointment-middle-section">
            {this.getServicesList(
              multiServiceList,
              sibblingBookingsTotalStartingFromZero
            ).map((multiServiceItem, multiItemIndex) => {
              let elementToReturn = "";
              let servicesStillLoading = this.areServicesStillLoading();
              let disabled =
                multiServiceItem.bookingId != currentBookingId ||
                servicesStillLoading;
              if (!multiServiceItem.noAccess) {
                if (
                  !limitedPermissions.canEditAllBookings &&
                  multiServiceItem.bookingId &&
                  limitedPermissions.bookingsEditableByCurrentUser.indexOf(
                    multiServiceItem.bookingId
                  ) < 0
                ) {
                  disabled = true;
                }
                multiServiceIndex = multiServiceList.indexOf(multiServiceItem);
                elementToReturn = (
                  <div
                    key={`multiItem${multiItemIndex}`}
                    className={`middle-section service-info fields pdbnull ${
                      disabled ? "disabled-row" : ""
                    }`}
                  >
                    {this.getServiceDropdown(
                      multiServiceItem,
                      multiServiceIndex,
                      multiItemIndex
                    )}
                    {this.getCostInput(
                      multiServiceItem,
                      multiServiceIndex,
                      multiItemIndex
                    )}
                    {this.getStaffDropdown(
                      multiServiceItem,
                      multiServiceIndex,
                      multiItemIndex
                    )}
                    {this.getDatePicker(
                      multiServiceItem,
                      multiServiceIndex,
                      multiItemIndex
                    )}
                    {this.getTimeDropdown(
                      multiServiceItem,
                      multiServiceIndex,
                      multiItemIndex
                    )}
                    {this.getDurationInput(
                      multiServiceItem,
                      multiServiceIndex,
                      multiItemIndex
                    )}
                    {/* {this.getRemoveServiceButton(multiServiceItem, multiItemIndex)} */}
                  </div>
                );
                //multiServiceIndex += 1;
              } else if (finishedLoadingSibblingBookings) {
                elementToReturn = (
                  <div
                    key={`multiItem${multiItemIndex}`}
                    className="middle-section service-info fields pdbnull disabled-row"
                  >
                    {this.getBookingRowsWithoutAccess()}
                  </div>
                );
              }
              return elementToReturn;
            })}
            {/* {this.getAddMultiServiceItemButton()} */}
            {
              <div className="total-duration">
                {window.APP.LANGUAGE.Pages.Appointment.TotalDurationService}{" "}
                <span className="font_600">
                  {this.calculateMultipleAppointmentsTotalDuration()}
                </span>
              </div>
            }
          </div>

          {this.getBottomSection()}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let propertiesToReturn = {
    offlineSquarePayment: state.bookingReducer.alert,
    appointmentStepData: state.appointmentStepReducer.appointmentStepData,
    limitedPermissions: state.appointmentStepReducer.limitedPermissions,
    bookingChannel: state.bookingReducer.bookingChannel,
    appIsVisible: state.appStatusReducer.appIsVisible,
    gotCustomerProfileData: state.customerProfileReducer.gotCustomerProfileData,
    customerProfileData: state.customerProfileReducer.customerProfileData,
    loadingBooking: state.bookingReducer.loadingBooking,
    sibblingBookingsTotalStartingFromZero:
      state.bookingReducer.sibblingBookingsTotalStartingFromZero,
    gotValidOffer: state.bookingReducer.gotValidOffer,
    loadingCustomerProfile: state.customerProfileReducer.loadingCustomerProfile,
    sendingBookingEmail: state.bookingReducer.sendingBookingEmail,
    finishedLoadingServicesAndOrganizationData:
      state.appointmentStepReducer.finishedLoadingServicesAndOrganizationData,
    isShowingAddressForm: state.appointmentStepReducer.isShowingAddressForm,
    shouldSaveAppointmentOnceWeGoBackFromCustomerProfile:
      state.appointmentStepReducer
        .shouldSaveAppointmentOnceWeGoBackFromCustomerProfile,
    temporaryBookingAddress:
      state.appointmentStepReducer.temporaryBookingAddress,
    previousMenu: state.menuReducer.previousMenu,
    finishedLoadingBooking: state.appointmentStepReducer.finishedLoadingBooking,
    advancedAppointmentStepData:
      state.advancedAppointmentStepReducer.advancedAppointmentStepData,
    currentBookingId: state.bookingReducer.currentBookingId,
    customerDropdownOpen: state.appointmentStepReducer.customerDropdownOpen,
    isMultiServiceAppointment: state.bookingReducer.isMultiServiceAppointment,
    sibblingBookingIds: state.bookingReducer.sibblingBookingIds,
    loadingTimesForCurrentResourceForClashSection:
      state.appointmentStepReducer
        .loadingTimesForCurrentResourceForClashSection,
    finishedLoadingSibblingBookings:
      state.bookingReducer.finishedLoadingSibblingBookings,
    bookingOnlyCustomerProfileData:
      state.customerProfileReducer.bookingOnlyCustomerProfileData,
    advancedAppointmentStepDataFromLastSave:
      state.advancedAppointmentStepReducer
        .advancedAppointmentStepDataFromLastSave,
    savingBooking: state.bookingReducer.savingBooking,
    loadedCachedData: state.appointmentStepReducer.loadedCachedData,
    isSibblingsMissingInUpdate:
      state.appointmentStepReducer.isSibblingsMissingInUpdate,
    finishedLoadingSibblingResources:
      state.bookingReducer.finishedLoadingSibblingResources,
    loadedResourcesForAllSibblings:
      state.bookingReducer.loadedResourcesForAllSibblings,
  };
  (state.bookingReducer.sibblingBookingIds || []).forEach((sibbling) => {
    propertiesToReturn[`loadingSibblingBooking_${sibbling.id}`] =
      state.bookingReducer[`loadingSibblingBooking_${sibbling.id}`];
  });
  return propertiesToReturn;
}
